<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h6>Trocar Plano</h6>
        <i class="bi bi-x-circle close-icon" @click="cancel"></i>
      </div>

      <div
        v-if="!isMatriculaAtiva"
        class="alert alert-warning d-flex justify-content-between align-items-center"
      >
        <span>Não é possível trocar o plano de uma matrícula não ativa.</span>
        <button class="btn btn-primary btn-sm" @click="cancel">Fechar</button>
      </div>

      <div v-if="isMatriculaAtiva">
        <div class="modal-body">
          <h5 class="section-title">Dados do Plano Atual</h5>
          <div v-if="planoAtual.turmas?.length" class="mb-3">
            <label>Turmas atuais (origem):</label>
            <ul><li v-for="(t, i) in planoAtual.turmas" :key="i">{{ t.turma_completa }}</li></ul>
          </div>
          <div class="row mb-3">
            <div class="col">
              <div class="form-group">
                <label>Categoria:</label>
                <input type="text" :value="planoAtual.categoria" class="form-control" disabled />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Tipo de Plano:</label>
                <input type="text" :value="planoAtual.tipo_plano" class="form-control" disabled />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Aulas por Semana:</label>
                <input type="text" :value="planoAtual.aulas_semana" class="form-control" disabled />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Qtd. de Parcelas:</label>
                <input
                  type="text"
                  :value="planoAtual.quantidade_parcelas"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col">
              <div class="form-group">
                <label>Nível:</label>
                <input type="text" :value="planoAtual.nivel" class="form-control" disabled />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Início da Vigência:</label>
                <input
                  type="date"
                  :value="toIsoDate(planoAtual.inicio_vigencia)"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Término da Vigência:</label>
                <input
                  type="date"
                  :value="toIsoDate(planoAtual.termino_vigencia)"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
          </div>

          <div v-if="!c04Ativa" class="mt-2">
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th># Parcela</th>
                    <th>Vencimento</th>
                    <th>Pago em</th>
                    <th class="text-end">Valor Pago</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="parcelasQuitadas.length === 0">
                    <td colspan="4" class="text-center text-muted">
                      Nenhuma obrigação anterior elegível.
                    </td>
                  </tr>
                  <tr v-for="p in parcelasQuitadas" :key="p.id">
                    <td>{{ p.numero }}</td>
                    <td>{{ globalUtils.formatarData(p.vencimento) }}</td>
                    <td>{{ globalUtils.formatarData(p.data_pagamento) }}</td>
                    <td class="text-end">
                      {{
                        Number(p.valor_pago || 0).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="parcelasQuitadas.length">
                  <tr>
                    <th colspan="3" class="text-end">Total Quitado</th>
                    <th class="text-end">
                      {{
                        totalQuitado.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <h5 class="section-title">Dados do Plano Novo</h5>
          <div class="row mb-3">
            <div class="col">
              <div class="form-group">
                <label>Categoria: <span class="required">*</span></label>
                <select
                  v-model="planoNovo.categoria_id"
                  class="form-control"
                  @change="handleCategoriaChange"
                >
                  <option value="">Selecione</option>
                  <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
                    {{ categoria.nome }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Tipo de Plano: <span class="required">*</span></label>
                <select
                  v-model="planoNovo.tipo_plano_id"
                  class="form-control"
                  @change="handleTipoPlanoChange"
                >
                  <option value="">Selecione</option>
                  <option v-for="tipo in tiposPlano" :key="tipo.id" :value="tipo.id">
                    {{ tipo.nome }} - {{ tipo.duracao }} dias
                  </option>
                </select>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Aulas por Semana:</label>
                <input type="text" v-model="planoNovo.aulas_semana" class="form-control" disabled />
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Qtd. de Parcelas:</label>
                <input
                  type="text"
                  v-model="planoNovo.quantidade_parcelas"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col">
              <div class="form-group">
                <label>Nível: <span class="required">*</span></label>
                <select v-model="planoNovo.nivel_id" class="form-control">
                  <option value="">Selecione</option>
                  <option v-for="nivel in niveis" :key="nivel.id" :value="nivel.id">
                    {{ nivel.nivel }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Início da Vigência: <span class="required">*</span></label>
                <input
                  type="date"
                  v-model="planoNovo.inicio_vigencia"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Término da Vigência:</label>
                <input
                  type="date"
                  v-model="planoNovo.termino_vigencia"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
          </div>

          <div v-if="planoNovo.nivel_id" class="mb-4">
            <label class="form-label">Turmas da Semana: <span class="required">*</span></label>
            <div class="table-responsive">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Turma(s)</th>
                    <th class="text-center">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(turma, index) in planoNovo.turmas" :key="index">
                    <td>
                      <select
                        v-model="turma.turma_id"
                        class="form-control"
                        @change="atualizarTurma(index)"
                      >
                        <option value="">Selecione</option>
                        <option
                          v-if="turma.turma_id && !resolverTurmaSelecionada(turma.turma_id)"
                          :value="turma.turma_id"
                          disabled
                        >Turma indisponível — selecione uma turma ativa</option>
                        <option
                          v-for="turmaDisponivel in turmasDisponiveis"
                          :key="`${turmaDisponivel.id}-${turmaDisponivel.dia}-${turmaDisponivel.horario}`"
                          :value="chaveTurmaDisponivel(turmaDisponivel)"
                        >
                          {{
                            `Turma: ${turmaDisponivel.id} | Dia: ${turmaDisponivel.dia} | Hora: ${String(
                              turmaDisponivel.horario || ""
                            ).slice(0, 5)} | Instrutor: ${turmaDisponivel.instrutor}`
                          }}
                        </option>
                      </select>
                    </td>
                    <td class="text-center">
                      <button @click="removerTurma(index)" class="btn btn-danger btn-sm">🗑️</button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="add-turma-container">
                <button class="btn btn-primary" @click="adicionarTurma">
                  <i class="bi bi-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h5 class="section-title">Mensalidade</h5>

            <div class="row g-2 align-items-end mb-2">
              <div class="col-md-2">
                <label class="form-label">Valor:</label>
                <input class="form-control" disabled :value="formatarValor(mensalidade.valor)" />
              </div>

              <div class="col-md-2">
                <label class="form-label">Desconto (%):</label>

                <input
                  v-if="trocaManagedAtiva"
                  class="form-control"
                  type="text"
                  inputmode="decimal"
                  v-model="mensalidade.desconto"
                  placeholder="0,00"
                  @input="atualizarResumoManaged"
                />

                <input
                  v-else
                  class="form-control"
                  type="number"
                  v-model="mensalidade.desconto"
                  min="0"
                  max="100"
                  @input="calcularValorComDescontoMensalidade"
                />
              </div>

              <div
                v-if="trocaManagedAtiva"
                class="col-md-2"
              >
                <label class="form-label">
                  Dia de Vencimento:
                  <span class="required">*</span>
                </label>

                <select
                  v-model="diaVencimentoMensalidadeTroca"
                  class="form-control"
                  :disabled="
                    carregandoDiasVencimentoCobranca ||
                    diaVencimentoHerdadoFrontend
                  "
                  @change="onDiaVencimentoTrocaChange"
                >
                  <option value="">Selecione</option>
                  <option
                    v-for="item in diasVencimentoCobranca"
                    :key="item.dia"
                    :value="String(item.dia)"
                  >
                    Dia {{ item.dia }}
                  </option>
                </select>

                <small
                  v-if="diaVencimentoHerdadoFrontend"
                  class="text-muted"
                >
                  Herdado do contrato atual.
                </small>

                <small
                  v-else-if="erroPoliticaCobranca"
                  class="text-danger"
                >
                  {{ erroPoliticaCobranca }}
                </small>
              </div>

              <div class="col-md-2">
                <label class="form-label">Valor com Desconto:</label>
                <input
                  class="form-control"
                  disabled
                  :value="c04Ativa && !previaAtualC04 ? 'A calcular' : formatarValor(mensalidade.valor_com_desconto)"
                />
              </div>

              <div class="col-md-2">
                <label class="form-label">
                  {{ trocaManagedAtiva ? '1º Vencimento (prévia):' : '1º Vencimento:' }}
                  <span class="required">*</span>
                </label>
                <input
                  class="form-control"
                  type="date"
                  v-model="mensalidade.primeiro_vencimento"
                  :disabled="trocaManagedAtiva"
                />
              </div>

              <div class="col-md-2">
                <label class="form-label">Qtd. de Pagamentos:</label>
                <input class="form-control" disabled :value="mensalidade.quantidade_pagamentos" />
              </div>

              <div class="col-md-2">
                <label class="form-label">
                  {{ c04Ativa ? 'Valor líquido após crédito:' : trocaManagedAtiva ? 'Valor Total Contratual:' : 'Valor Total:' }}
                </label>
                <input
                  class="form-control"
                  disabled
                  :value="
                    c04Ativa && !previaAtualC04
                      ? 'A calcular'
                      : (c04Ativa || trocaManagedAtiva)
                      ? globalUtils.formatarValor(mensalidade.valor_total)
                      : totalProrataBrutoNovoPlano.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        })
                  "
                />
              </div>
            </div>

            <p v-if="trocaManagedAtiva" class="alert alert-info">
              Confira a composição anterior e o complemento. Os valores pagos não serão abatidos novamente do complemento.
            </p>

            <div
              v-if="
                trocaManagedAtiva &&
                carregandoPreviewTrocaManaged
              "
              class="alert alert-info py-2 px-3 mt-2 mb-0"
            >
              Calculando a prévia financeira da troca pelo backend...
            </div>

            <div
              v-if="
                trocaManagedAtiva &&
                erroPreviewTrocaManaged
              "
              class="alert alert-warning py-2 px-3 mt-2 mb-0"
            >
              {{ erroPreviewTrocaManaged }}
            </div>

            <div
              v-if="
                trocaManagedAtiva &&
                previewTrocaManaged
              "
              class="mt-2"
            >
              <div class="row g-2">
                <div class="col-6 col-md-4" v-for="item in [
                  ['Novo plano (G)', 'G'], ['Composição anterior (A)', 'A'], ['Já pago (P)', 'P'],
                  ['Pendências preservadas (U)', 'U'], ['Novo complemento (C)', 'C'], ['Total ainda exigível', 'total_exigivel']
                ]" :key="item[1]">
                  <div class="border rounded p-2 h-100">
                    <small class="text-muted d-block">{{ item[0] }}</small>
                    <strong>{{ globalUtils.formatarValor(previewTrocaManaged.composicao[item[1]]) }}</strong>
                  </div>
                </div>
              </div>
              <p class="mt-2">As parcelas e os boletos anteriores permanecem preservados. Somente o complemento gera novas obrigações.</p>
              <label class="form-label">Quantidade de parcelas do complemento</label>
              <input class="form-control" type="number" min="1" max="120" v-model.number="quantidadeComplemento" @change="recalcularComplemento" />
              <div class="mt-2">
                <div v-for="(parcela, i) in previewTrocaManaged.obrigacoes" :key="i" class="row g-2 border rounded p-2 mb-2">
                  <strong class="col-12">Parcela {{ i + 1 }}</strong>
                  <label class="col-6 col-md-3">Vencimento<input class="form-control" type="date" v-model="parcela.data_vencimento" /></label>
                  <label class="col-6 col-md-3">Valor<input class="form-control" type="text" v-model="parcela.valor" /></label>
                  <label class="col-12 col-md-6">Motivo do ajuste<input class="form-control" type="text" v-model="parcela.motivo" /></label>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary" @click="validarDistribuicaoComplemento">Validar distribuição ajustada</button>
              <details class="mt-2"><summary>Obrigações anteriores preservadas ({{ previewTrocaManaged.obrigacoes_preservadas.length }})</summary>
                <ul><li v-for="p in previewTrocaManaged.obrigacoes_preservadas" :key="p.id">
                  #{{ p.id }} · {{ p.contrato }} · {{ globalUtils.formatarValor(p.valor) }} · {{ p.pago ? 'Paga' : 'Pendente' }}
                </li></ul>
              </details>
              <details><summary>Boletos anteriores preservados ({{ previewTrocaManaged.boletos_preservados.length }})</summary>
                <ul><li v-for="b in previewTrocaManaged.boletos_preservados" :key="b.id">#{{ b.id }} · {{ b.status }} · {{ globalUtils.formatarValor(b.valor) }}</li></ul>
              </details>
            </div>

            <div
              v-if="!c04Ativa && !trocaManagedAtiva"
              class="row g-2 align-items-start"
            >
              <div class="col-md-2">
                <label class="form-label">Desconto (quitado):</label>
                <input
                  type="text"
                  class="form-control text-success"
                  :value="globalUtils.formatarValor(totalQuitado, true)"
                  disabled
                />
              </div>

              <div class="col-md-2">
                <label class="form-label">Saldo a pagar:</label>
                <input
                  type="text"
                  class="form-control saldo-bg fw-bold"
                  :value="globalUtils.formatarValor(mensalidade.valor_total)"
                  disabled
                />
              </div>

              <div class="col-md-2">
                <label class="form-label">Parcela prevista:</label>
                <input
                  type="text"
                  class="form-control"
                  :value="globalUtils.formatarValor(valorParcelaPrevista)"
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            v-if="trocaManagedAtiva"
            class="alert alert-info py-2 px-3 mt-3"
          >
            As linhas regulares abaixo são somente uma prévia de configuração.
            Devem usar a forma <strong>Boleto</strong> e a mesma conta financeira.
            O backend gerará as obrigações definitivas e aplicará o crédito.
            Pagamentos adicionais continuam sendo lançados separadamente.
          </div>

          <div v-if="c04Ativa" class="form-section">
            <h5 class="section-title">Prévia financeira da Troca de Plano</h5>
            <p v-if="contratoAtualGerenciado || mensalidade.pagamentos.some(p=>isBoletoSemantico(p.forma_pagamento_id))">Boletos usam a mesma conta e o dia permitido pela política de cobrança. O primeiro vencimento é independente do início do plano.</p>
            <p>O desconto comercial é aplicado antes do crédito proporcional. As obrigações anteriores permanecem integralmente preservadas.</p>
            <button type="button" class="btn btn-outline-primary" :disabled="carregandoC04 || isSaving" @click="calcularC04">Calcular / atualizar prévia</button>
            <p v-if="erroC04" class="alert alert-warning mt-2">{{ erroC04 }}</p>
            <template v-if="previaC04">
              <p v-if="previaC04.bloqueio" class="alert alert-warning">{{ previaC04.bloqueio.mensagem }}</p>
              <p v-for="v in previaC04.verificacoes || []" :key="v.codigo" class="alert alert-warning">{{ v.motivo }}</p>
              <div v-if="previaC04.encontrados" class="mt-2">
                <p>A base é a soma das parcelas válidas do contrato atual, independentemente da quitação e sem recuperar créditos de trocas passadas.</p>
                <div class="row g-2">
                  <label class="col-md-3">Base comercial anterior (R$)<input type="text" class="form-control" :value="baseFormatadaC04" readonly /></label>
                </div>
              </div>
              <details v-if="previaC04.requerConferencia" class="mt-2" open>
                <summary>Conferência histórica necessária para concluir</summary>
                <p>Os ajustes ficam registrados somente na memória desta troca.</p>
                <div v-for="campo in previaC04.camposNecessarios || []" :key="campo.campo" class="mt-2">
                  <p class="text-warning">{{ campo.motivo }}</p>
                  <label v-if="campo.campo === 'duracaoMeses'">Duração anterior (meses)<input type="number" min="1" class="form-control" v-model="anteriorC04.duracaoMeses" /></label>
                  <label v-if="campo.campo === 'inicio'">Início anterior<input type="date" class="form-control" v-model="anteriorC04.inicio" /></label>
                  <label v-if="campo.campo === 'termino'">Término anterior<input type="date" class="form-control" v-model="anteriorC04.termino" /></label>
                </div>
                <label class="mt-2 conferencia-historica">
                  <input type="checkbox" v-model="conferenciaC04" :disabled="carregandoC04 || isSaving" />
                  <span>Conferi os parâmetros históricos apresentados.</span>
                </label>
              </details>
              <div v-if="previaAtualC04" class="row g-2 mt-2">
                <div class="col-md-4" v-for="item in resumoC04" :key="item[1]">
                  <small>{{ item[0] }}</small><strong class="d-block">{{ globalUtils.formatarValor(previaC04.calculo[item[1]] / 100) }}</strong>
                </div>
              </div>
              <details v-if="previaC04.obrigacoesPreservadas?.length" class="mt-2"><summary>Obrigações anteriores preservadas</summary>
                <ul><li v-for="p in previaC04.obrigacoesPreservadas" :key="p.id">#{{ p.id }} · {{ p.contrato }} · {{ globalUtils.formatarValor(p.valor) }} · {{ globalUtils.formatarData(p.data_vencimento) }} · {{ p.data_pagamento || p.data_recebimento ? 'Paga' : 'Pendente' }}</li></ul>
              </details>
              <p v-if="previaAtualC04 && previaC04.calculo?.creditoExcedenteCentavos" class="mt-2">O crédito excedente é apenas registrado, sem devolução ou saldo reutilizável.</p>
              <p v-if="chaveC04 !== chaveConferidaC04" class="text-warning mt-2">Os dados mudaram. Atualize a prévia antes de confirmar.</p>
            </template>
          </div>

          <div v-if="mensalidade.pagamentos.length" class="mb-4">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Forma de Pagamento</th>
                  <th>Autorização</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Pagamento</th>
                  <th>Recebimento</th>
                  <th>Conta Financeira</th>
                  <th v-if="existeCheque">Banco nº</th>
                  <th v-if="existeCheque">Agência</th>
                  <th v-if="existeCheque">Cheque nº</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(pagamento, index) in mensalidade.pagamentos" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>
                    <select
                      v-model="pagamento.forma_pagamento_id"
                      class="form-control"
                      required
                      @change="onPagamentoFormaChange(pagamento, index)"
                    >
                      <option value="">Selecione</option>
                      <option v-for="forma in formasPagamento" :key="forma.id" :value="forma.id">
                        {{ forma.nome }}
                      </option>
                    </select>
                  </td>

                  <td>
                    <input
                      v-if="isFormaComAutorizacao(pagamento.forma_pagamento_id)"
                      v-model="pagamento.numero_autorizacao"
                      type="text"
                      class="form-control"
                      placeholder="Autorização"
                      @input="onNumeroAutorizacaoMensalInput(pagamento)"
                      :disabled="isFormaAInformar(pagamento.forma_pagamento_id)"
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      v-model="pagamento.data_vencimento"
                      class="form-control"
                      :disabled="trocaManagedAtiva && !pagamento.adicional"
                    />
                  </td>

                  <td>
                    <template v-if="pagamento.adicional">
                      <input
                        v-model="pagamento.valor"
                        type="text"
                        class="form-control"
                        @focus="desformatarValorAdicional(pagamento)"
                        @blur="formatarValorAdicional(pagamento)"
                        placeholder="R$ 0,00"
                      />
                    </template>
                    <template v-else>
                      <input
                        type="text"
                        :value="globalUtils.formatarValor(pagamento.valor)"
                        class="form-control"
                        readonly
                      />
                    </template>
                  </td>

                  <td>
                    <input
                      type="date"
                      v-model="pagamento.data_pagamento"
                      class="form-control"
                      :disabled="
                        isFormaAInformar(pagamento.forma_pagamento_id) ||
                        ((trocaManagedAtiva || (c04Ativa && isBoletoSemantico(pagamento.forma_pagamento_id))) && !pagamento.adicional)
                      "
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      v-model="pagamento.data_recebimento"
                      class="form-control"
                      disabled
                    />
                  </td>

                  <td>
                    <template v-if="isFormaAInformar(pagamento.forma_pagamento_id)">
                      <input type="text" class="form-control" value="A informar" disabled />
                    </template>
                    <template v-else>
                      <select
                        v-model.number="pagamento.conta_financeira_id"
                        class="form-control"
                        :required="pagamento.data_pagamento && pagamento.data_pagamento.trim() !== ''"
                        @change="onContaFinanceiraMensalChange(pagamento)"
                      >
                        <option :value="null">Selecione</option>
                        <option v-for="conta in contasFinanceiras" :key="conta.id" :value="conta.id">
                          {{ conta.apelido }}
                        </option>
                      </select>
                    </template>
                  </td>

                  <td v-if="existeCheque">
                    <input
                      v-if="isCheque(pagamento.forma_pagamento_id)"
                      type="text"
                      v-model="pagamento.banco_numero"
                      class="form-control"
                      placeholder="Banco nº"
                    />
                  </td>

                  <td v-if="existeCheque">
                    <input
                      v-if="isCheque(pagamento.forma_pagamento_id)"
                      type="text"
                      v-model="pagamento.agencia"
                      class="form-control"
                      placeholder="Agência"
                    />
                  </td>

                  <td v-if="existeCheque">
                    <input
                      v-if="isCheque(pagamento.forma_pagamento_id)"
                      type="text"
                      v-model="pagamento.cheque_numero"
                      class="form-control"
                      placeholder="Cheque nº"
                    />
                  </td>

                  <td class="text-center">
                    <button
                      class="btn btn-danger btn-sm"
                      :disabled="trocaManagedAtiva && !pagamento.adicional"
                      v-if="!c04Ativa" @click="removerPagamento(index)"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="!c04Ativa && !trocaManagedAtiva" class="d-flex justify-content-end mt-2"><button type="button" class="btn btn-primary" aria-label="Acrescentar parcela" :disabled="isSaving || Number(mensalidade.valor_total) <= 0" @click="adicionarPagamento">+</button></div>
          <div v-if="!c04Ativa && !trocaManagedAtiva" class="mt-3">
            <p>Anterior: {{ globalUtils.formatarValor(totalMarcadoPago) }} com marcação de pagamento; {{ globalUtils.formatarValor(totalQuitado - totalMarcadoPago) }} pendentes.</p>
            <p>Total dos novos lançamentos ordinários: {{ globalUtils.formatarValor(totalDistribuido) }}. Diferença para o complemento: {{ globalUtils.formatarValor(totalDistribuido - Number(mensalidade.valor_total || 0)) }}.</p>
            <p v-if="parcelasVariadas">A distribuição contém valores variados.</p>
            <p v-if="Number(mensalidade.valor_total) === 0" class="alert alert-info">Esta troca não gerou novas parcelas. Os pagamentos anteriores foram preservados.</p>
            <p v-if="erroContexto" class="text-danger">{{ erroContexto }}</p>
            <p v-if="Number(mensalidade.valor_total) < 0" class="text-danger">O valor preservado excede o novo plano. É necessária uma regra específica para o saldo excedente.</p>
            <p>As marcações de pagamento e datas futuras são dados do sistema; não comprovam recebimento bancário.</p>
          </div>
          <div class="mb-3">
            <label class="form-label">Observações:</label>
            <textarea v-model="mensalidade.observacoes" class="form-control" rows="3"></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cancel">Cancelar</button>
          <button
            :class="['btn', isSaving ? 'btn-success' : 'btn-primary']"
            :disabled="!formValid || isSaving || !isMatriculaAtiva"
            @click="trocar"
          >
            {{ isSaving ? "Trocando…" : "Trocar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { centavos, distribuir, calcularPlano, redistribuir } from "@/utils/financeiroPlano";

import { mensagemTurmaIndisponivel } from '@/utils/turmasSelecao';
import { reactive, ref, computed, onMounted, watch, watchEffect, getCurrentInstance } from "vue";
import axios from "@/services/axios";
const c04Ativa = true;
const versaoOrigem = ref("");
const erroContexto = ref("");
import globalUtils from "@/utils/globalUtils.js";

const props = defineProps({
  planoAtual: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const emit = defineEmits(["cancelar", "trocarSucesso"]);

const instance = getCurrentInstance();
if (!instance) {
  throw new Error("getCurrentInstance retornou null. Verifique se a função está dentro do setup.");
}

const planoNovo = reactive({
  categoria_id: "",
  tipo_plano_id: "",
  nivel_id: "",
  inicio_vigencia: "",
  termino_vigencia: "",
  aulas_semana: "",
  quantidade_parcelas: "",
  turmas: [],
});

const mensalidade = reactive({
  valor: 0,
  desconto: 0,
  valor_com_desconto: 0,
  primeiro_vencimento: "",
  quantidade_pagamentos: "",
  valor_total: 0,
  observacoes: "",
  pagamentos: [],
});

const categorias = ref([]);
const tiposPlano = ref([]);
const todosTiposPlano = ref([]);
const niveis = ref([]);
const turmasDisponiveis = ref([]);
const formasPagamento = ref([]);
const convenios = ref([]);
const contasFinanceiras = ref([]);

const diasVencimentoCobranca = ref([]);
const carregandoDiasVencimentoCobranca = ref(false);
const erroPoliticaCobranca = ref("");
const politicaCobrancaAplicavelId = ref(null);
const diaVencimentoMensalidadeTroca = ref("");
const diaVencimentoHerdadoFrontend = ref(false);

let sequenciaCargaPoliticaCobranca = 0;

const quantidadeComplemento = ref(null);
const parcelasComplemento = ref(null);
const configuracaoComplemento = ref({ forma: null, conta: null });
let operacaoComplemento = null;
let distribuicaoValidadaComplemento = '';

const recalcularComplemento = () => {
  parcelasComplemento.value = null;
  void carregarPreviewTrocaManaged();
};
const validarDistribuicaoComplemento = () => {
  parcelasComplemento.value = previewTrocaManaged.value.obrigacoes.map(p => ({
    valor: p.valor, data_vencimento: p.data_vencimento, motivo: p.motivo || ''
  }));
  void carregarPreviewTrocaManaged();
};

const previewTrocaManaged =
  ref(null);

const carregandoPreviewTrocaManaged =
  ref(false);

const erroPreviewTrocaManaged =
  ref("");

let sequenciaPreviewTrocaManaged =
  0;

const isSaving = ref(false);

const parcelasQuitadas = ref([]);

const norm = (s) =>
  (s ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const getFormaById = (id) => formasPagamento.value.find((f) => String(f.id) === String(id));

const normalizarMoedaManaged = (value) => {
  let raw = String(value ?? "")
    .trim()
    .replace(/\s/g, "")
    .replace(/^R\$/i, "");

  if (!raw) return null;

  if (raw.includes(",")) {
    raw = raw
      .replace(/\./g, "")
      .replace(",", ".");
  }

  const match = /^(\d+)(?:\.(\d+))?$/.exec(raw);
  if (!match) return null;

  const inteiro = match[1];
  const fracao = match[2] || "";

  if (
    fracao.length > 2 &&
    /[1-9]/.test(fracao.slice(2))
  ) {
    return null;
  }

  return `${window.BigInt(inteiro).toString()}.${fracao.padEnd(2, "0").slice(0, 2)}`;
};

const normalizarPercentualManaged = (value) => {
  let raw = String(value ?? "")
    .trim()
    .replace(/\s/g, "")
    .replace("%", "")
    .replace(",", ".");

  if (!raw) raw = "0";

  const match = /^(\d+)(?:\.(\d+))?$/.exec(raw);
  if (!match) return null;

  const inteiro = match[1];
  const fracao = match[2] || "";

  if (
    fracao.length > 2 &&
    /[1-9]/.test(fracao.slice(2))
  ) {
    return null;
  }

  const canonical =
    `${window.BigInt(inteiro).toString()}.${fracao.padEnd(2, "0").slice(0, 2)}`;

  const [i, f] =
    canonical.split(".");

  const basisPoints =
    window.BigInt(i) * 100n +
    window.BigInt(f);

  if (basisPoints > 10000n) {
    return null;
  }

  return canonical;
};

const centavosManaged = (value) => {
  const canonical =
    normalizarMoedaManaged(value);

  if (!canonical) return null;

  const [inteiro, centavos] =
    canonical.split(".");

  return (
    window.BigInt(inteiro) *
      100n +
    window.BigInt(centavos)
  );
};

const moedaManagedDeCentavos = (value) => {
  if (
    typeof value !== "bigint" ||
    value < 0n
  ) {
    return null;
  }

  return `${value / 100n}.${String(value % 100n).padStart(2, "0")}`;
};

const calcularMensalidadeLiquidaManaged = (
  valorBruto,
  desconto
) => {
  const bruto =
    centavosManaged(valorBruto);

  const descontoCanonical =
    normalizarPercentualManaged(
      desconto
    );

  if (
    bruto === null ||
    descontoCanonical === null
  ) {
    return null;
  }

  const [
    inteiro,
    fracao
  ] =
    descontoCanonical.split(".");

  const basisPoints =
    window.BigInt(inteiro) *
      100n +
    window.BigInt(fracao);

  const numerador =
    bruto *
    (
      10000n -
      basisPoints
    );

  const liquido =
    (
      numerador +
      5000n
    ) /
    10000n;

  return moedaManagedDeCentavos(
    liquido
  );
};

const quantidadePagamentosManaged = () => {
  const raw =
    String(
      mensalidade.quantidade_pagamentos ??
      ""
    ).trim();

  if (!/^[1-9]\d*$/.test(raw)) {
    return null;
  }

  const quantidade =
    Number(raw);

  return (
    Number.isSafeInteger(
      quantidade
    ) &&
    quantidade > 0 &&
    quantidade <= 120
  )
    ? quantidade
    : null;
};

const adicionarMesesIsoManaged = (
  isoDate,
  offset
) => {
  const match =
    /^(\d{4})-(\d{2})-(\d{2})$/
      .exec(
        String(isoDate || "").trim()
      );

  if (!match) return null;

  const anoInicial =
    Number(match[1]);

  const mesInicial =
    Number(match[2]);

  const dia =
    Number(match[3]);

  if (
    !Number.isSafeInteger(offset) ||
    offset < 0 ||
    mesInicial < 1 ||
    mesInicial > 12 ||
    dia < 1 ||
    dia > 28
  ) {
    return null;
  }

  const totalMeses =
    anoInicial * 12 +
    (
      mesInicial -
      1
    ) +
    offset;

  const ano =
    Math.floor(
      totalMeses / 12
    );

  const mes =
    totalMeses % 12 +
    1;

  return (
    String(ano).padStart(4, "0") +
    "-" +
    String(mes).padStart(2, "0") +
    "-" +
    String(dia).padStart(2, "0")
  );
};

const calcularPrimeiroVencimentoRegularManaged = (
  dataInicio,
  diaVencimento
) => {
  const match =
    /^(\d{4})-(\d{2})-(\d{2})$/
      .exec(
        String(dataInicio || "").trim()
      );

  const dia =
    Number(diaVencimento);

  if (
    !match ||
    !Number.isInteger(dia) ||
    dia < 1 ||
    dia > 28
  ) {
    return null;
  }

  const primeiroMes =
    `${match[1]}-${match[2]}-${String(dia).padStart(2, "0")}`;

  return adicionarMesesIsoManaged(
    primeiroMes,
    1
  );
};

const contratoAtualGerenciado =
  computed(() => {
    const id =
      Number(
        props.planoAtual
          ?.politica_cobranca_id
      );

    return (
      Number.isInteger(id) &&
      id > 0
    );
  });

const isBoletoSemantico = (formaId) => {
  const forma =
    getFormaById(formaId);

  if (!forma) return false;

  return (
    String(
      forma.codigo_sistema ||
      ""
    )
      .trim()
      .toUpperCase() ===
    "BOLETO"
  );
};

const parcelasRegularesTroca = () =>
  (mensalidade.pagamentos || [])
    .filter(
      p =>
        !p.adicional
    );

const trocaManagedAtiva =
  computed(() => {
    if (c04Ativa) return false;
    if (
      contratoAtualGerenciado.value
    ) {
      return true;
    }

    return parcelasRegularesTroca()
      .some(
        p =>
          isBoletoSemantico(
            p.forma_pagamento_id
          )
      );
  });

const propagarBoletoRegularTroca = (
  origem
) => {
  if (
    !origem ||
    origem.adicional ||
    !isBoletoSemantico(
      origem.forma_pagamento_id
    )
  ) {
    return;
  }

  const conta =
    origem.conta_financeira_id ??
    null;

  for (
    const p of
    parcelasRegularesTroca()
  ) {
    p.forma_pagamento_id =
      origem.forma_pagamento_id;

    p.numero_autorizacao =
      null;

    p.data_pagamento =
      null;

    p.data_recebimento =
      null;

    if (
      conta !== null &&
      conta !== ""
    ) {
      p.conta_financeira_id =
        conta;
    }
  }
};

const propagarContaBoletoRegularTroca = (
  origem
) => {
  if (
    !origem ||
    origem.adicional ||
    !isBoletoSemantico(
      origem.forma_pagamento_id
    )
  ) {
    return;
  }

  const conta =
    origem.conta_financeira_id ??
    null;

  for (
    const p of
    parcelasRegularesTroca()
  ) {
    p.forma_pagamento_id =
      origem.forma_pagamento_id;

    p.conta_financeira_id =
      conta;

    p.numero_autorizacao =
      null;

    p.data_pagamento =
      null;

    p.data_recebimento =
      null;
  }
};

const reconstruirPreviewManaged = (
  formaId = null,
  contaId = null
) => {
  if (
    !trocaManagedAtiva.value
  ) {
    return;
  }

  const adicionais =
    (mensalidade.pagamentos || [])
      .filter(
        p =>
          p.adicional
      );

  const primeiraRegular =
    parcelasRegularesTroca()[0];

  const forma =
    formaId ??
    primeiraRegular
      ?.forma_pagamento_id ??
    "";

  const conta =
    contaId ??
    primeiraRegular
      ?.conta_financeira_id ??
    null;

  const quantidade =
    quantidadePagamentosManaged();

  const valorLiquido =
    calcularMensalidadeLiquidaManaged(
      mensalidade.valor,
      mensalidade.desconto
    );

  const primeiro =
    mensalidade.primeiro_vencimento;

  if (
    !quantidade ||
    !valorLiquido ||
    !primeiro
  ) {
    mensalidade.pagamentos =
      adicionais;

    return;
  }

  const regulares = [];

  for (
    let index = 0;
    index < quantidade;
    index += 1
  ) {
    const vencimento =
      adicionarMesesIsoManaged(
        primeiro,
        index
      );

    if (!vencimento) {
      mensalidade.pagamentos =
        adicionais;

      return;
    }

    regulares.push({
      forma_pagamento_id:
        forma,

      data_vencimento:
        vencimento,

      valor:
        valorLiquido,

      data_pagamento:
        null,

      data_recebimento:
        null,

      conta_financeira_id:
        conta,

      numero_autorizacao:
        null,

      banco_numero:
        "",

      agencia:
        "",

      cheque_numero:
        "",

      adicional:
        false
    });
  }

  mensalidade.pagamentos = [
    ...regulares,
    ...adicionais
  ];
};

const atualizarResumoManaged = () => {
  if (
    !trocaManagedAtiva.value
  ) {
    return;
  }

  const valorBruto =
    normalizarMoedaManaged(
      mensalidade.valor
    );

  const desconto =
    normalizarPercentualManaged(
      mensalidade.desconto
    );

  const valorLiquido =
    calcularMensalidadeLiquidaManaged(
      mensalidade.valor,
      mensalidade.desconto
    );

  const quantidade =
    quantidadePagamentosManaged();

  if (
    !valorBruto ||
    desconto === null ||
    !valorLiquido ||
    !quantidade
  ) {
    mensalidade.valor_com_desconto =
      "";

    mensalidade.valor_total =
      "";

    return;
  }

  mensalidade.valor =
    valorBruto;

  mensalidade.desconto =
    desconto;

  mensalidade.valor_com_desconto =
    valorLiquido;

  const liquidoCentavos =
    centavosManaged(
      valorLiquido
    );

  mensalidade.valor_total =
    moedaManagedDeCentavos(
      liquidoCentavos *
      window.BigInt(
        quantidade
      )
    );

  reconstruirPreviewManaged();

  void carregarPreviewTrocaManaged();
};

const atualizarPrimeiroVencimentoManaged = () => {
  if (
    !trocaManagedAtiva.value
  ) {
    return;
  }

  mensalidade.primeiro_vencimento =
    calcularPrimeiroVencimentoRegularManaged(
      planoNovo.inicio_vigencia,
      diaVencimentoMensalidadeTroca.value
    ) ||
    "";

  atualizarResumoManaged();
};

const onDiaVencimentoTrocaChange = () => {
  diaVencimentoHerdadoFrontend.value =
    false;

  atualizarPrimeiroVencimentoManaged();
};

const carregarDiasVencimentoTroca = async () => {
  const dataInicio =
    String(
      planoNovo.inicio_vigencia ||
      ""
    ).trim();

  const seq =
    ++sequenciaCargaPoliticaCobranca;

  if (!dataInicio) {
    diasVencimentoCobranca.value =
      [];

    politicaCobrancaAplicavelId.value =
      null;

    erroPoliticaCobranca.value =
      "";

    diaVencimentoHerdadoFrontend.value =
      false;

    mensalidade.primeiro_vencimento =
      "";

    return false;
  }

  carregandoDiasVencimentoCobranca.value =
    true;

  erroPoliticaCobranca.value =
    "";

  try {
    const { data } =
      await axios.get(
        "/operacional/matriculas/politica-cobranca-aplicavel",
        {
          params: {
            data_inicio:
              dataInicio
          }
        }
      );

    if (
      seq !==
      sequenciaCargaPoliticaCobranca
    ) {
      return false;
    }

    const dias =
      Array.isArray(
        data?.dias_vencimento
      )
        ? data.dias_vencimento
            .map(
              item => ({
                dia:
                  Number(
                    item?.dia
                  )
              })
            )
            .filter(
              item =>
                Number.isInteger(
                  item.dia
                ) &&
                item.dia >= 1 &&
                item.dia <= 28
            )
            .sort(
              (a, b) =>
                a.dia -
                b.dia
            )
        : [];

    diasVencimentoCobranca.value =
      dias;

    const politicaId =
      Number(
        data?.politica_cobranca_id
      );

    politicaCobrancaAplicavelId.value =
      (
        Number.isInteger(
          politicaId
        ) &&
        politicaId > 0
      )
        ? politicaId
        : null;

    const diaAtualContrato =
      Number(
        props.planoAtual
          ?.dia_vencimento_mensalidade
      );

    const diaAtualPermitido =
      contratoAtualGerenciado.value &&
      Number.isInteger(
        diaAtualContrato
      ) &&
      dias.some(
        item =>
          item.dia ===
          diaAtualContrato
      );

    if (diaAtualPermitido) {
      diaVencimentoMensalidadeTroca.value =
        String(
          diaAtualContrato
        );

      diaVencimentoHerdadoFrontend.value =
        true;
    } else {
      diaVencimentoHerdadoFrontend.value =
        false;

      const selecionado =
        Number(
          diaVencimentoMensalidadeTroca.value
        );

      if (
        !Number.isInteger(
          selecionado
        ) ||
        !dias.some(
          item =>
            item.dia ===
            selecionado
        )
      ) {
        diaVencimentoMensalidadeTroca.value =
          "";
      }
    }

    atualizarPrimeiroVencimentoManaged();

    return (
      dias.length >
      0
    );
  } catch (error) {
    if (
      seq !==
      sequenciaCargaPoliticaCobranca
    ) {
      return false;
    }

    diasVencimentoCobranca.value =
      [];

    politicaCobrancaAplicavelId.value =
      null;

    diaVencimentoHerdadoFrontend.value =
      false;

    mensalidade.primeiro_vencimento =
      "";

    erroPoliticaCobranca.value =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      "Não foi possível carregar os dias de vencimento da política aplicável.";

    return false;
  } finally {
    if (
      seq ===
      sequenciaCargaPoliticaCobranca
    ) {
      carregandoDiasVencimentoCobranca.value =
        false;
    }
  }
};

const limparPreviewTrocaManaged = () => {
  sequenciaPreviewTrocaManaged +=
    1;

  previewTrocaManaged.value =
    null;

  erroPreviewTrocaManaged.value =
    "";

  carregandoPreviewTrocaManaged.value =
    false;
};

const carregarPreviewTrocaManaged = async () => {
  if (
    !trocaManagedAtiva.value
  ) {
    limparPreviewTrocaManaged();
    return false;
  }

  const matriculaId =
    Number(
      props.planoAtual?.id
    );

  const regulares =
    parcelasRegularesTroca();

  const primeira =
    regulares[0];

  const dia =
    Number(
      diaVencimentoMensalidadeTroca.value
    );

  const formaId =
    Number(
      primeira?.forma_pagamento_id ?? configuracaoComplemento.value.forma
    );

  const contaId =
    Number(
      primeira?.conta_financeira_id ?? configuracaoComplemento.value.conta
    );

  const politicaId =
    Number(
      politicaCobrancaAplicavelId.value
    );

  const valorMensal =
    normalizarMoedaManaged(
      mensalidade.valor
    );

  const desconto =
    normalizarPercentualManaged(
      mensalidade.desconto
    );

  if (
    !Number.isSafeInteger(
      matriculaId
    ) ||
    matriculaId <= 0 ||
    !planoNovo.inicio_vigencia ||
    !planoNovo.categoria_id ||
    !planoNovo.tipo_plano_id ||
    !Number.isInteger(dia) ||
    !diasVencimentoCobranca.value
      .some(
        item =>
          item.dia ===
          dia
      ) ||
    !Number.isInteger(formaId) ||
    formaId <= 0 ||
    !isBoletoSemantico(
      formaId
    ) ||
    !Number.isInteger(contaId) ||
    contaId <= 0 ||
    !Number.isInteger(politicaId) ||
    politicaId <= 0 ||
    carregandoDiasVencimentoCobranca.value ||
    !!erroPoliticaCobranca.value ||
    !valorMensal ||
    desconto === null
  ) {
    limparPreviewTrocaManaged();
    return false;
  }

  const requisicao =
    ++sequenciaPreviewTrocaManaged;

  carregandoPreviewTrocaManaged.value =
    true;

  erroPreviewTrocaManaged.value =
    "";

  try {
    const { data } =
      await axios.post(
        "/operacional/matriculas/salvar-trocas-planos/preview",
        {
          id_matricula:
            matriculaId,

          termino_vigencia: planoNovo.termino_vigencia,
          quantidade_complemento: quantidadeComplemento.value,
          parcelas_complemento: parcelasComplemento.value,
          motivo_ajuste: mensalidade.observacoes || '',
          inicio_vigencia:
            planoNovo.inicio_vigencia,

          categoria_id:
            Number(
              planoNovo.categoria_id
            ),

          tipo_plano_id:
            Number(
              planoNovo.tipo_plano_id
            ),

          encerrar_vigencia_final_ano:
            planoNovo
              .encerrar_vigencia_final_ano ===
            true,

          valor_mensalidade:
            valorMensal,

          desconto_mensalidade:
            desconto,

          dia_vencimento_mensalidade:
            dia,

          mensalidade_forma_pagamento_id:
            formaId,

          mensalidade_conta_financeira_id:
            contaId
        }
      );

    if (
      requisicao !==
      sequenciaPreviewTrocaManaged
    ) {
      return false;
    }

    if (
      String(
        data?.tipo_preview ||
        ""
      ).toUpperCase() !==
        "TROCA_PLANO" ||
      Number(
        data?.matricula_id
      ) !==
        matriculaId ||
      Number(
        data?.politica_cobranca_id
      ) !==
        politicaId ||
      Number(
        data?.dia_vencimento_mensalidade
      ) !==
        dia ||
      !Array.isArray(
        data?.obrigacoes
      )
    ) {
      throw new Error(
        "O backend retornou uma prévia de troca de plano inconsistente."
      );
    }

    if (previewTrocaManaged.value?.versao_origem !== data.versao_origem) operacaoComplemento = crypto.randomUUID();
    configuracaoComplemento.value = { forma: formaId, conta: contaId };
    distribuicaoValidadaComplemento = JSON.stringify(data.obrigacoes.map(p => ({ valor: p.valor, data_vencimento: p.data_vencimento, motivo: p.motivo || '' })));
    previewTrocaManaged.value = data;

    if (
      data?.valor_mensalidade
    ) {
      mensalidade.valor =
        data.valor_mensalidade;
    }

    if (
      data?.desconto_mensalidade !==
      undefined &&
      data?.desconto_mensalidade !==
      null
    ) {
      mensalidade.desconto =
        data.desconto_mensalidade;
    }

    if (
      data?.valor_mensalidade_liquido
    ) {
      mensalidade.valor_com_desconto =
        data.valor_mensalidade_liquido;
    }

    if (
      data?.primeiro_vencimento_regular
    ) {
      mensalidade.primeiro_vencimento =
        data.primeiro_vencimento_regular;
    }

    const quantidade =
      Number(
        data?.quantidade_pagamentos
      );

    if (
      Number.isSafeInteger(
        quantidade
      ) &&
      quantidade > 0
    ) {
      mensalidade.quantidade_pagamentos =
        quantidade;
    }

    if (
      data?.resumo?.total_contratual
    ) {
      mensalidade.valor_total =
        data.resumo.total_contratual;
    }

    if (
      data?.termino_vigencia
    ) {
      planoNovo.termino_vigencia =
        data.termino_vigencia;
    }

    if (
      data?.dia_vencimento_herdado ===
      true
    ) {
      diaVencimentoHerdadoFrontend.value =
        true;
    }

    const observacaoAtual =
      String(
        mensalidade.observacoes ||
        ""
      ).trim();

    if (
      observacaoAtual.startsWith(
        "O cálculo do Valor Total de "
      ) &&
      observacaoAtual.includes(
        "do plano (pró-rata)."
      )
    ) {
      mensalidade.observacoes =
        "";
    }

    const adicionais =
      (mensalidade.pagamentos || [])
        .filter(
          item =>
            item?.adicional ===
            true
        );

    const regularesAtuais =
      parcelasRegularesTroca();

    const regularesPreview =
      data.obrigacoes.map(
        (
          obrigacao,
          index
        ) => {
          const atual =
            regularesAtuais[index] ||
            {};

          return {
            ...atual,

            forma_pagamento_id:
              formaId,

            conta_financeira_id:
              contaId,

            data_vencimento:
              obrigacao.data_vencimento,

            /*
             * Mantém no state o valor monetário canônico devolvido
             * pelo backend. A template é responsável apenas pela
             * apresentação em R$; não armazenamos moeda formatada
             * dentro da obrigação de preview.
             */
            valor:
              obrigacao.valor,

            data_pagamento:
              null,

            data_recebimento:
              null,

            numero_autorizacao:
              null,

            adicional:
              false,

            _preview_troca_managed:
              true,

            _preview_valor_bruto:
              obrigacao.valor_bruto,

            _preview_valor_credito:
              obrigacao.valor_credito,

            _preview_compensada:
              obrigacao
                .compensada_integralmente ===
              true,

            _preview_composicoes:
              Array.isArray(
                obrigacao.composicoes
              )
                ? obrigacao.composicoes
                : []
          };
        }
      );

    mensalidade.pagamentos = [
      ...regularesPreview,
      ...adicionais
    ];

    return true;
  } catch (error) {
    if (
      requisicao !==
      sequenciaPreviewTrocaManaged
    ) {
      return false;
    }

    previewTrocaManaged.value =
      null;

    erroPreviewTrocaManaged.value =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Não foi possível calcular a prévia financeira da troca de plano.";

    return false;
  } finally {
    if (
      requisicao ===
      sequenciaPreviewTrocaManaged
    ) {
      carregandoPreviewTrocaManaged.value =
        false;
    }
  }
};


watch(
  [
    () =>
      trocaManagedAtiva.value,

    () =>
      planoNovo.inicio_vigencia
  ],
  async (
    [
      managedAtiva
    ]
  ) => {
    if (!managedAtiva) {
      return;
    }

    await carregarDiasVencimentoTroca();
  },
  {
    immediate: true
  }
);

watch(
  [
    () =>
      trocaManagedAtiva.value,

    () =>
      planoNovo.inicio_vigencia,

    () =>
      planoNovo.categoria_id,

    () =>
      planoNovo.tipo_plano_id,

    () =>
      diaVencimentoMensalidadeTroca.value,

    () =>
      mensalidade.valor,

    () =>
      mensalidade.desconto,

    () => mensalidade.observacoes,
    () => planoNovo.termino_vigencia,

    () =>
      parcelasRegularesTroca()[0]
        ?.forma_pagamento_id ??
      null,

    () =>
      parcelasRegularesTroca()[0]
        ?.conta_financeira_id ??
      null,

    () =>
      politicaCobrancaAplicavelId.value,

    () =>
      carregandoDiasVencimentoCobranca.value,

    () =>
      erroPoliticaCobranca.value
  ],
  () => {
    if (
      !trocaManagedAtiva.value
    ) {
      limparPreviewTrocaManaged();
      return;
    }

    void carregarPreviewTrocaManaged();
  }
);

const isCartao = (formaId) => {
  const n = norm(getFormaById(formaId)?.nome);
  return n.includes("cartao");
};

const isCartaoCreditoAVista = (formaId) => {
  const n = norm(getFormaById(formaId)?.nome);
  return (
    n === "cartao de credito" ||
    n === "cartao de credito a vista" ||
    (n.includes("cartao") && n.includes("credito") && n.includes("vista"))
  );
};

const isCartaoCreditoParcelado = (formaId) => {
  const n = norm(getFormaById(formaId)?.nome);
  return n.includes("cartao") && n.includes("credito") && n.includes("parcelado");
};

const isCartaoDebito = (formaId) => {
  const n = norm(getFormaById(formaId)?.nome);
  return n.includes("cartao") && n.includes("debito");
};

// const getPagamentosMensalidadeOrdenados = () => {
//   return (mensalidade.pagamentos || [])
//     .filter((p) => !p.adicional)
//     .slice()
//     .sort((a, b) => String(a?.data_vencimento || "").localeCompare(String(b?.data_vencimento || "")));
// };

const getBlocoParceladoDaParcela = (pag, originalIndex = null) => {
  const lista = getPagamentosMensalidadeOrdenadosComOrigem();
  const idx =
    originalIndex !== null
      ? getIndiceOrdenadoDaParcela(originalIndex)
      : lista.findIndex((item) => item.p === pag);

  if (idx === -1) return [];
  if (!isCartaoCreditoParcelado(lista[idx]?.p?.forma_pagamento_id)) return [lista[idx].p];

  let ini = idx;
  let fim = idx;

  while (ini > 0 && isCartaoCreditoParcelado(lista[ini - 1]?.p?.forma_pagamento_id)) ini--;
  while (fim < lista.length - 1 && isCartaoCreditoParcelado(lista[fim + 1]?.p?.forma_pagamento_id)) fim++;

  return lista.slice(ini, fim + 1).map((item) => item.p);
};

const isInicioBlocoParcelado = (pag, originalIndex = null) => {
  if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return false;

  const lista = getPagamentosMensalidadeOrdenadosComOrigem();
  const idx =
    originalIndex !== null
      ? getIndiceOrdenadoDaParcela(originalIndex)
      : lista.findIndex((item) => item.p === pag);

  if (idx === -1) return false;
  if (idx === 0) return true;

  return !isCartaoCreditoParcelado(lista[idx - 1]?.p?.forma_pagamento_id);
};

const propagarBlocoParceladoParaLinhasVazias = (pag, originalIndex = null) => {
  if (!isInicioBlocoParcelado(pag, originalIndex)) return;

  const lista = getPagamentosMensalidadeOrdenadosComOrigem();
  const idx =
    originalIndex !== null
      ? getIndiceOrdenadoDaParcela(originalIndex)
      : lista.findIndex((item) => item.p === pag);

  if (idx === -1) return;

  const autorizacao = (pag.numero_autorizacao || "").trim();
  const conta = pag.conta_financeira_id ?? null;

  for (let i = idx + 1; i < lista.length; i++) {
    const atual = lista[i].p;
    const formaAtual = atual?.forma_pagamento_id;

    if (formaAtual !== null && formaAtual !== "" && formaAtual !== undefined) {
      break;
    }

    atual.forma_pagamento_id = pag.forma_pagamento_id;

    if (!(atual.numero_autorizacao || "").trim() && autorizacao) {
      atual.numero_autorizacao = autorizacao;
    }

    if (
      atual.conta_financeira_id === null ||
      atual.conta_financeira_id === "" ||
      atual.conta_financeira_id === undefined
    ) {
      atual.conta_financeira_id = conta;
    }

    if (!atual.data_pagamento) {
      atual.data_pagamento = atual.data_vencimento || "";
    }
  }
};

const getNumeroParcelaNoBlocoParcelado = (pag, originalIndex = null) => {
  const bloco = getBlocoParceladoDaParcela(pag, originalIndex);
  const idx = bloco.findIndex((p) => p === pag);
  return idx >= 0 ? idx + 1 : 1;
};

const getDataBaseBlocoParcelado = (pag) => {
  const bloco = getBlocoParceladoDaParcela(pag);
  const primeira = bloco?.[0];

  if (!primeira) return null;

  return (
    primeira.data_pagamento ||
    primeira.data_vencimento ||
    pag.data_pagamento ||
    pag.data_vencimento ||
    null
  );
};

const replicarAutorizacaoNoBlocoParcelado = (pag) => {
  if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return;
  const bloco = getBlocoParceladoDaParcela(pag);
  const valor = (pag.numero_autorizacao || "").trim();

  bloco.forEach((p) => {
    p.numero_autorizacao = valor || null;
  });
};

const replicarContaNoBlocoParcelado = (pag) => {
  if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return;
  const bloco = getBlocoParceladoDaParcela(pag);
  const conta = pag.conta_financeira_id ?? null;

  bloco.forEach((p) => {
    p.conta_financeira_id = conta;
  });
};

const getPagamentosMensalidadeOrdenadosComOrigem = () => {
  return (mensalidade.pagamentos || [])
    .map((p, originalIndex) => ({ p, originalIndex }))
    .filter(({ p }) => !p.adicional)
    .sort((a, b) =>
      String(a?.p?.data_vencimento || "").localeCompare(String(b?.p?.data_vencimento || ""))
    );
};

const getIndiceOrdenadoDaParcela = (originalIndex) => {
  const lista = getPagamentosMensalidadeOrdenadosComOrigem();
  return lista.findIndex((item) => item.originalIndex === originalIndex);
};

const onNumeroAutorizacaoMensalInput = (pag) => {
  if (isCartaoCreditoParcelado(pag?.forma_pagamento_id)) {
    replicarAutorizacaoNoBlocoParcelado(pag);
  }
};

const onContaFinanceiraMensalChange = (pag) => {
  if (
    !pag?.adicional &&
    isBoletoSemantico(
      pag?.forma_pagamento_id
    )
  ) {
    propagarContaBoletoRegularTroca(
      pag
    );

    return;
  }

  if (isCartaoCreditoParcelado(pag?.forma_pagamento_id)) {
    replicarContaNoBlocoParcelado(pag);
  }
};

const isFormaComAutorizacao = (formaId) => {
  return (
    isCartaoCreditoAVista(formaId) ||
    isCartaoCreditoParcelado(formaId) ||
    isCartaoDebito(formaId)
  );
};

function parseISOorBR(d) {
  if (!d) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(String(d))) {
    return new Date(`${d}T00:00:00`);
  }

  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(d));
  if (m) {
    const [, dd, mm, yyyy] = m;
    return new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
  }

  const x = new Date(d);
  return isNaN(x.getTime()) ? null : x;
}

function toIsoDate(value) {
  const d = parseISOorBR(value);
  if (!d) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function todayIsoLocal() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}


function addDaysToIso(isoDate, days) {
  if (!isoDate) return "";
  const d = new Date(`${isoDate}T00:00:00`);
  d.setDate(d.getDate() + Number(days || 0));

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function fromIsoToLocalDate(isoDate) {
  if (!isoDate) return null;
  const [yyyy, mm, dd] = String(isoDate).split("-").map(Number);
  if (!yyyy || !mm || !dd) return null;
  return new Date(yyyy, mm - 1, dd, 0, 0, 0, 0);
}

function diffDaysInclusive(startDate, endDate) {
  if (!startDate || !endDate) return 0;

  const start = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
    0, 0, 0, 0
  );

  const end = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    0, 0, 0, 0
  );

  const msPerDay = 24 * 60 * 60 * 1000;
  const diff = Math.floor((end.getTime() - start.getTime()) / msPerDay);

  return diff >= 0 ? diff + 1 : 0;
}

const isMatriculaAtiva = computed(() => {
  const fimStr = props.planoAtual?.termino_vigencia;
  const end = parseISOorBR(fimStr);
  if (!end) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return end >= today;
});

const totalQuitado = computed(() =>
  parcelasQuitadas.value.reduce((s, p) => s + centavos(p.valor_pago || 0), 0)/100
);

const totalBrutoNovoPlano = computed(() => {
  return Number(totalProrataBrutoNovoPlano.value || 0);
});

const totalProrataBrutoNovoPlano = computed(() => {
  const valorParcela = parseFloat(mensalidade.valor) || 0;
  const qtdPagamentos = parseInt(planoNovo.quantidade_parcelas) || 0;
  const duracaoNova = Number(
    tiposPlano.value.find(p => String(p.id) === String(planoNovo.tipo_plano_id))?.duracao || 0
  );

  if (valorParcela <= 0 || qtdPagamentos <= 0 || duracaoNova <= 0) return 0;

  const valorCheio = valorParcela * qtdPagamentos;
  const valorDia = valorCheio / duracaoNova;
  const diasRestantes = diasRestantesVigencia.value;

  return valorDia * diasRestantes;
});

const diasRestantesVigencia = computed(() => {
  const inicio = fromIsoToLocalDate(planoNovo.inicio_vigencia);
  const termino = fromIsoToLocalDate(planoNovo.termino_vigencia);

  if (!inicio || !termino) return 0;

  return diffDaysInclusive(inicio, termino);
});


async function carregarParcelasQuitadas() {
  if (c04Ativa) return;
  try {
    const matriculaId = props.planoAtual?.id;
    const contrato = props.planoAtual?.numero_contrato;

    if (!matriculaId || !contrato) {
      parcelasQuitadas.value = [];
      return;
    }

    const { data } = await axios.get("/operacional/pagamentos-matriculas/contexto-troca", {
      params: { matricula_id: matriculaId, contrato },
    });

    parcelasQuitadas.value = Array.isArray(data?.itens) ? data.itens : [];
    versaoOrigem.value = data.versao;
    erroContexto.value = "";
  } catch (e) {
    erroContexto.value = e.response?.data?.error || "Não foi possível conferir as obrigações anteriores.";
    versaoOrigem.value = "";
    parcelasQuitadas.value = [];
  } finally {
    calcularValorTotalMensalidade();
    recalcularParcelas();
  }
}

async function carregarContasFinanceiras() {
  try {
    const response = await axios.get('/financeiro/contas-financeiras/selecao-operacional', { params: { fluxo: 'troca_plano' } });
    contasFinanceiras.value = response.data.data || response.data;
  } catch (error) {
    console.error("❌ Erro ao carregar contas financeiras:", error);
  }
}

async function carregarCategorias() {
  try {
    const response = await axios.get("/cadastros/categorias-de-planos");
    const data = response.data.data || response.data;
    categorias.value = Array.isArray(data) ? data.filter((c) => c.ativo) : [];
  } catch (error) {
    console.error("Erro ao carregar categorias:", error);
  }
}

async function carregarTodosTiposPlano() {
  try {
    const resp = await axios.get("/cadastros/tipos-planos", {
      params: {
        page: 1,
        limit: 10000,
        sort: "duracao",
        order: "asc",
      },
    });

    const lista = resp.data?.data || resp.data || [];
    todosTiposPlano.value = Array.isArray(lista)
      ? lista.filter((t) => t.ativo !== false && t.ativo !== 0)
      : [];
  } catch (error) {
    console.error("Erro ao carregar todos os tipos de plano:", error);
    todosTiposPlano.value = [];
  }
}

async function carregarTiposPlano() {
  if (!planoNovo.categoria_id) {
    tiposPlano.value = [];
    return;
  }

  try {
    const respPlanos = await axios.get("/cadastros/planos-matriculas", {
      params: {
        categoria_id: planoNovo.categoria_id,
        page: 1,
        limit: 10000,
      },
    });

    const planosArray = respPlanos.data?.data || respPlanos.data || [];
    const planosAtivos = Array.isArray(planosArray)
      ? planosArray.filter((plano) =>
          "ativo" in plano ? plano.ativo === true || plano.ativo === 1 : true
        )
      : [];

    const lista = planosAtivos
      .map((plano) => {
        const tipo = todosTiposPlano.value.find(
          (t) => String(t?.nome || "").trim() === String(plano?.tipo || "").trim()
        );

        return {
          id: tipo ? tipo.id : null,
          nome: plano?.tipo || "",
          duracao: tipo?.duracao ?? null,
          duracao_meses: tipo?.duracao_meses ?? null,
          aulas_semana: plano?.aulas_semana ?? 0,
          quantidade_parcelas: plano?.quantidade_parcelas ?? 0,
          valor_mensalidade: plano?.valor_parcela ?? 0,
        };
      })
      .filter((t) => t.id !== null);

    lista.sort((a, b) => {
      const da = Number.isFinite(a.duracao) ? a.duracao : Number.MAX_SAFE_INTEGER;
      const db = Number.isFinite(b.duracao) ? b.duracao : Number.MAX_SAFE_INTEGER;
      return da - db;
    });

    tiposPlano.value = lista;

    if (planoNovo.tipo_plano_id) {
      const sel = tiposPlano.value.find((p) => String(p.id) === String(planoNovo.tipo_plano_id));
      if (sel) {
        planoNovo.aulas_semana = sel.aulas_semana;
        planoNovo.quantidade_parcelas = sel.quantidade_parcelas;
        mensalidade.quantidade_pagamentos = sel.quantidade_parcelas;
        mensalidade.valor = sel.valor_mensalidade;
        calcularValorComDescontoMensalidade();
      }
    }
  } catch (error) {
    console.error("Erro ao carregar tipos de plano:", error?.response?.data || error);
  }
}

async function handleCategoriaChange() {
  planoNovo.tipo_plano_id = "";
  planoNovo.aulas_semana = "";
  planoNovo.quantidade_parcelas = "";
  tiposPlano.value = [];

  planoNovo.inicio_vigencia = todayIsoLocal();
  planoNovo.termino_vigencia = c04Ativa ? '' : toIsoDate(props.planoAtual?.termino_vigencia);


  mensalidade.valor = 0;
  mensalidade.valor_com_desconto = 0;
  mensalidade.quantidade_pagamentos = "";
  mensalidade.valor_total = 0;
  mensalidade.pagamentos = [];

  if (planoNovo.categoria_id) {
    await carregarTiposPlano();
  }
}

function calcularTerminoVigencia() {
  const planoSelecionado = tiposPlano.value.find(
    (p) => String(p.id) === String(planoNovo.tipo_plano_id)
  );

  if (!planoNovo.inicio_vigencia) {
    planoNovo.inicio_vigencia = todayIsoLocal();
  }

  if (!planoSelecionado) {
    planoNovo.termino_vigencia = "";
    return;
  }

  const duracaoNova = Number(planoSelecionado.duracao || 0);

  if (duracaoNova <= 0) {
    planoNovo.termino_vigencia = "";
    return;
  }

  // Regra inclusiva:
  // início 07/05 + plano de 30 dias = término 05/06
  planoNovo.termino_vigencia = c04Ativa ? terminoCivilC04(planoNovo.inicio_vigencia, planoSelecionado.duracao_meses) : addDaysToIso(planoNovo.inicio_vigencia, duracaoNova - 1);

  planoNovo.aulas_semana = planoSelecionado.aulas_semana;
  planoNovo.quantidade_parcelas = planoSelecionado.quantidade_parcelas;
  mensalidade.quantidade_pagamentos = planoNovo.quantidade_parcelas;
}


function handleTipoPlanoChange() {
  const planoSelecionado = tiposPlano.value.find(
    (p) => String(p.id) === String(planoNovo.tipo_plano_id)
  );

  if (!planoSelecionado) return;

  planoNovo.aulas_semana = planoSelecionado.aulas_semana;
  planoNovo.quantidade_parcelas = planoSelecionado.quantidade_parcelas;

  mensalidade.quantidade_pagamentos = planoSelecionado.quantidade_parcelas;
  mensalidade.valor = planoSelecionado.valor_mensalidade;

  calcularTerminoVigencia();
  calcularValorComDescontoMensalidade();

  if (
    trocaManagedAtiva.value
  ) {
    carregarDiasVencimentoTroca();
  }
}

async function carregarNiveis() {
  try {
    const { data } = await axios.get("/cadastros/niveis-turmas", {
      params: { page: 1, limit: 10000 },
    });
    const lista = data?.data ?? data ?? [];
    niveis.value = Array.isArray(lista) ? lista.filter((n) => n.ativo) : [];
  } catch (error) {
    console.error("Erro ao carregar níveis:", error);
    niveis.value = [];
  }
}

const idxDia = (d) => {
  let s = String(d || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/-?feira/g, "")
    .trim();
  s = s.split(/\s+/)[0].slice(0, 3);
  const mapa = { seg: 1, ter: 2, qua: 3, qui: 4, sex: 5, sab: 6, dom: 7 };
  return mapa[s] ?? 99;
};

const toMin = (h) => {
  const m = String(h || "").match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!m) return Number.MAX_SAFE_INTEGER;
  return +m[1] * 60 + +m[2];
};

async function carregarTurmasDisponiveis() {
  if (!planoNovo.nivel_id) {
    turmasDisponiveis.value = [];
    return;
  }

  try {
    const res = await axios.get("/cadastros/dias-horarios-turmas", { params: { ativo: true } });
    const diasData = res.data.data || res.data || [];

    const nomeNivel = niveis.value.find((n) => String(n.id) === String(planoNovo.nivel_id))?.nivel;

    turmasDisponiveis.value = diasData
      .filter((d) => (nomeNivel ? d.nivel_nome === nomeNivel : true))
      .map((d) => ({
        id: d.turma_id,
        dia: d.dia_semana,
        horario: d.horario,
        instrutor: d.instrutor_nome || "Não informado",
        nivel: d.nivel_nome,
      }))
      .sort(
        (a, b) =>
          Number(a.id) - Number(b.id) || idxDia(a.dia) - idxDia(b.dia) || toMin(a.horario) - toMin(b.horario)
      );
  } catch (error) {
    console.error("❌ Erro ao carregar turmas disponíveis:", error);
    turmasDisponiveis.value = [];
  }
}

async function carregarFormasPagamento() {
  try {
    const { data } = await axios.get("/cadastros/formas-pagamento");

    const normFp = (s) =>
      (s ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();

    const lista = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];

    const ordemPersonalizada = {
      "pix": 1,
      "especie": 2,
      "cartao de credito a vista": 3,
      "cartao de credito parcelado": 4,
      "cartao de debito": 5,
      "boleto": 6,
      "transferencia bancaria": 7,
      "cheque": 8,
      "a informar": 9,
    };

    formasPagamento.value = lista
      .filter((fp) => normFp(fp.nome) !== "brinde")
      .sort((a, b) => {
        const oa = ordemPersonalizada[normFp(a.nome)] ?? 999;
        const ob = ordemPersonalizada[normFp(b.nome)] ?? 999;
        if (oa !== ob) return oa - ob;
        return a.nome.localeCompare("pt-BR");
      });
  } catch (error) {
    console.error("Erro ao carregar formas de pagamento:", error);
    formasPagamento.value = [];
  }
}

async function carregarConvenios() {
  try {
    const response = await axios.get("/cadastros/convenios");
    const data = response.data.data || response.data;
    convenios.value = Array.isArray(data) ? data.filter((c) => c.ativo) : [];
  } catch (error) {
    console.error("Erro ao carregar convênios:", error);
  }
}

function calcularDataRecebimento(dataBaseIso, formaId, numeroParcela = 1) {
  if (!dataBaseIso || !formaId) return "";
  return globalUtils.calcularDataRecebimento(
    dataBaseIso,
    formaId,
    formasPagamento.value,
    numeroParcela
  ) || "";
}

const recalcularRecebimentoParcelaMensal = (pag) => {
  const formaId = pag?.forma_pagamento_id;

  if (!formaId || isFormaAInformar(formaId)) {
    setIfChanged(pag, "data_recebimento", "");
    return;
  }

  if (isCartaoCreditoParcelado(formaId)) {
    const numeroParcela = getNumeroParcelaNoBlocoParcelado(pag);
    const dataBaseOperacao = getDataBaseBlocoParcelado(pag);

    if (!dataBaseOperacao) {
      setIfChanged(pag, "data_recebimento", "");
      return;
    }

    const rec = calcularDataRecebimento(dataBaseOperacao, formaId, numeroParcela) || "";
    setIfChanged(pag, "data_recebimento", rec);
    return;
  }

  if (pag.data_pagamento && String(pag.data_pagamento).trim() !== "") {
    const rec = calcularDataRecebimento(pag.data_pagamento, formaId, 1) || "";
    setIfChanged(pag, "data_recebimento", rec);
  } else {
    setIfChanged(pag, "data_recebimento", "");
  }
};

const recalcularRecebimentoBlocoParcelado = (pag) => {
  const bloco = getBlocoParceladoDaParcela(pag);
  if (!bloco.length) return;

  const primeira = bloco[0];

  if (!primeira.data_pagamento) {
    primeira.data_pagamento = primeira.data_vencimento || "";
  }

  const dataBaseOperacao = getDataBaseBlocoParcelado(primeira);

  bloco.forEach((p, idx) => {
    if (!p.data_pagamento) {
      p.data_pagamento = p.data_vencimento || "";
    }

    if (!dataBaseOperacao) {
      setIfChanged(p, "data_recebimento", "");
      return;
    }

    const rec = calcularDataRecebimento(
      dataBaseOperacao,
      p.forma_pagamento_id,
      idx + 1
    ) || "";

    setIfChanged(p, "data_recebimento", rec);
  });
};

function isFormaAInformar(formaId) {
  const f = formasPagamento.value.find((fp) => String(fp.id) === String(formaId));
  return f && String(f.nome).trim().toLowerCase() === "a informar";
}

function setIfChanged(obj, key, val) {
  if (obj[key] !== val) obj[key] = val;
}

function aplicarRegraAInformar(p) {
  if (!p) return;
  if (isFormaAInformar(p.forma_pagamento_id)) {
    setIfChanged(p, "data_pagamento", "");
    setIfChanged(p, "conta_financeira_id", null);
    setIfChanged(p, "data_recebimento", "");
  }
}

function onPagamentoFormaChange(pagamento, index = null) {
  if (c04Ativa && isBoletoSemantico(pagamento?.forma_pagamento_id)) {
    pagamento.data_pagamento=null;pagamento.data_recebimento=null;pagamento.numero_autorizacao=null;
    propagarBoletoRegularTroca(pagamento);return;
  }
  if (pagamento && !isCheque(pagamento.forma_pagamento_id)) {
    setIfChanged(pagamento, "banco_numero", "");
    setIfChanged(pagamento, "agencia", "");
    setIfChanged(pagamento, "cheque_numero", "");
  }

  if (!pagamento?.forma_pagamento_id) {
    setIfChanged(pagamento, "data_pagamento", "");
    setIfChanged(pagamento, "data_recebimento", "");
    setIfChanged(pagamento, "conta_financeira_id", null);
    setIfChanged(pagamento, "numero_autorizacao", null);
    return;
  }

  const formaId = pagamento.forma_pagamento_id;

  if (
    !pagamento.adicional &&
    isBoletoSemantico(
      formaId
    )
  ) {
    setIfChanged(
      pagamento,
      "numero_autorizacao",
      null
    );

    setIfChanged(
      pagamento,
      "data_pagamento",
      null
    );

    setIfChanged(
      pagamento,
      "data_recebimento",
      null
    );

    propagarBoletoRegularTroca(
      pagamento
    );

    reconstruirPreviewManaged(
      formaId,
      pagamento.conta_financeira_id
    );

    carregarDiasVencimentoTroca();

    return;
  }

  if (
    !pagamento.adicional &&
    trocaManagedAtiva.value
  ) {
    setIfChanged(
      pagamento,
      "data_pagamento",
      null
    );

    setIfChanged(
      pagamento,
      "data_recebimento",
      null
    );

    setIfChanged(
      pagamento,
      "numero_autorizacao",
      null
    );

    return;
  }


  if (!isFormaComAutorizacao(formaId)) {
    setIfChanged(pagamento, "numero_autorizacao", null);
  }

  if (isFormaAInformar(formaId)) {
    setIfChanged(pagamento, "data_pagamento", "");
    setIfChanged(pagamento, "conta_financeira_id", null);
    setIfChanged(pagamento, "data_recebimento", "");
    setIfChanged(pagamento, "numero_autorizacao", null);
    return;
  }

  if (!pagamento.data_pagamento) {
    setIfChanged(pagamento, "data_pagamento", pagamento.data_vencimento || "");
  }

  if (isCartaoCreditoParcelado(formaId)) {
    propagarBlocoParceladoParaLinhasVazias(pagamento, index);

    const bloco = getBlocoParceladoDaParcela(pagamento, index);

    const comAutorizacao = bloco.find((x) => (x.numero_autorizacao || "").trim());
    if (comAutorizacao) {
      setIfChanged(
        pagamento,
        "numero_autorizacao",
        (comAutorizacao.numero_autorizacao || "").trim() || null
      );
    }

    const comConta = bloco.find((x) => x.conta_financeira_id != null);
    if (comConta) {
      setIfChanged(pagamento, "conta_financeira_id", comConta.conta_financeira_id);
    }

    replicarAutorizacaoNoBlocoParcelado(pagamento);
    replicarContaNoBlocoParcelado(pagamento);
    recalcularRecebimentoBlocoParcelado(pagamento);
    return;
  }

  recalcularRecebimentoParcelaMensal(pagamento);
}

watch(
  () => mensalidade.pagamentos.map((p) => [p.forma_pagamento_id, p.data_pagamento]),
  () => {
    mensalidade.pagamentos.forEach((p) => {
      aplicarRegraAInformar(p);

      if (isCartaoCreditoParcelado(p.forma_pagamento_id)) {
        recalcularRecebimentoBlocoParcelado(p);
      } else {
        recalcularRecebimentoParcelaMensal(p);
      }
    });
  },
  { deep: false }
);

watch(
  () => planoNovo.nivel_id,
  async (novoNivel) => {
    if (novoNivel) {
      await carregarTurmasDisponiveis();
      planoNovo.turmas = [];
    } else {
      turmasDisponiveis.value = [];
      planoNovo.turmas = [];
    }
  }
);

watch(
  () => mensalidade.primeiro_vencimento,
  (novaData) => {
    if (novaData) {
      distribuirParcelasMensalidade();
    }
  }
);

watch(
  () => totalQuitado.value,
  () => {
    calcularValorTotalMensalidade();
    recalcularParcelas();
  }
);

watch(
  () => planoNovo.inicio_vigencia,
  () => {
    if (!planoNovo.tipo_plano_id) return;

    calcularTerminoVigencia();
    calcularValorComDescontoMensalidade();

    if (planoNovo.tipo_plano_id) {
      atualizarObservacaoProrata();
    }
  }
);

watch(
  () => [
    planoNovo.inicio_vigencia,
    planoNovo.termino_vigencia,
    planoNovo.tipo_plano_id,
    mensalidade.desconto
  ],
  () => {
    calcularValorComDescontoMensalidade();
  }
);


watch(
  () => [totalProrataBrutoNovoPlano.value, diasRestantesVigencia.value],
  () => {
    if (planoNovo.tipo_plano_id) {
      atualizarObservacaoProrata();
    }
  },
  { immediate: true }
);

watchEffect(() => {
  if (planoNovo.nivel_id && planoNovo.aulas_semana && planoNovo.turmas.length === 0) {
    planoNovo.turmas = Array.from({ length: Number(planoNovo.aulas_semana) }, () => ({
      turma_id: "",
      id: null,
      dia: "",
      horario: "",
      instrutor: "",
      turma_completa: "",
    }));
  }
});

function adicionarTurma() {
  planoNovo.turmas.push({ turma_id: "" });
}

function removerTurma(index) {
  planoNovo.turmas.splice(index, 1);
}

function chaveTurmaDisponivel(turma) {
  if (!turma) return "";

  return `${turma.id}-${turma.dia}-${turma.horario}`;
}

// Uma opção é identificada pelo slot inteiro; dias também contêm hífens.
function normalizarChaveTurma(valor) {
  return String(valor ?? "").trim().replace(/(\d{2}:\d{2}):00$/, "$1");
}

function resolverTurmaSelecionada(valor) {
  const chave = normalizarChaveTurma(valor);
  const opcoes = turmasDisponiveis.value.filter(
    turma => normalizarChaveTurma(chaveTurmaDisponivel(turma)) === chave
  );
  return opcoes.length === 1 ? opcoes[0] : null;
}

function descreverTurmaDisponivel(turma) {
  return `Turma: ${turma.id} | Dia: ${turma.dia} | Hora: ${turma.horario} | Instrutor: ${turma.instrutor}`;
}

function completarTurmas() {
  const chaves = new Set();
  return planoNovo.turmas.map((turma, index) => {
    const selecionada = resolverTurmaSelecionada(turma.turma_id);
    const chave = normalizarChaveTurma(turma.turma_id);
    if (!selecionada || chaves.has(chave)) {
      throw new Error(`A turma ${index + 1} é inválida, duplicada ou ambígua. Atualize as opções e selecione novamente.`);
    }
    chaves.add(chave);
    return {
      ...selecionada,
      turma_id: chaveTurmaDisponivel(selecionada),
      dia: selecionada.dia,
      horario: selecionada.horario,
      turma_completa: descreverTurmaDisponivel(selecionada),
    };
  });
}

function atualizarTurma(index) {
  const valor = planoNovo.turmas[index].turma_id;
  const selecionada = resolverTurmaSelecionada(valor);
  planoNovo.turmas[index] = selecionada ? {
    ...selecionada,
    turma_id: chaveTurmaDisponivel(selecionada),
    dia: selecionada.dia,
    horario: selecionada.horario,
    turma_completa: descreverTurmaDisponivel(selecionada),
  } : { turma_id: valor, id: null, dia: '', horario: '', instrutor: '', turma_completa: '' };
}

function recalcularParcelas() {
  if (c04Ativa) return;
  if (trocaManagedAtiva.value) { reconstruirPreviewManaged(); return; }
  const linhas = mensalidade.pagamentos.filter(p=>!p.adicional);
  if (Number(mensalidade.valor_total) < 0) return;
  redistribuir(centavos(mensalidade.valor_total),linhas);
}

function removerPagamento(index) {
  const pagamento = mensalidade.pagamentos[index];

  if (pagamento.data_pagamento || pagamento.data_recebimento) {
    alert("❌ Não é possível excluir um pagamento que já foi quitado.");
    return;
  }

  const naoPagos = mensalidade.pagamentos.filter(
    (p) => !p.data_pagamento || p.data_pagamento.trim() === ""
  );

  if (naoPagos.length === 1) {
    alert("⚠️ Não é possível excluir a última parcela não paga.");
    return;
  }

  mensalidade.pagamentos.splice(index, 1);
  recalcularParcelas();
}

function formatarValor(valor) {
  return globalUtils.formatarValor(valor);
}

function calcularValorComDescontoMensalidade() {
  if (c04Ativa) return;
  if (trocaManagedAtiva.value) { atualizarResumoManaged(); return; }
  const duracao = Number(tiposPlano.value.find(p=>String(p.id)===String(planoNovo.tipo_plano_id))?.duracao || 0);
  if (!duracao || !Number(mensalidade.valor) || !Number(planoNovo.quantidade_parcelas) || !diasRestantesVigencia.value) return;
  mensalidade.valor_com_desconto = (calcularPlano({referencia:mensalidade.valor,quantidade:Number(planoNovo.quantidade_parcelas),duracao,dias:diasRestantesVigencia.value,desconto:mensalidade.desconto || 0})/100).toFixed(2);

  calcularValorTotalMensalidade();
}

function calcularValorTotalMensalidade() {
  if (c04Ativa) return;
  if (trocaManagedAtiva.value) { atualizarResumoManaged(); return; }
  const liquido = (centavos(mensalidade.valor_com_desconto || 0) - centavos(totalQuitado.value.toFixed(2)))/100;
  mensalidade.valor_total = liquido.toFixed(2);
  if (liquido === 0) mensalidade.pagamentos = mensalidade.pagamentos.filter(p=>p.adicional);
}

const valorParcelaPrevista = computed(()=>Number(mensalidade.pagamentos.find(p=>!p.adicional)?.valor || 0));

function distribuirParcelasMensalidade() {
  if (c04Ativa) return;
  if (trocaManagedAtiva.value) { reconstruirPreviewManaged(); return; }
  if (!mensalidade.primeiro_vencimento || mensalidade.pagamentos.length > 0) return;

  const qtd = parseInt(mensalidade.quantidade_pagamentos) || 0;
  if (qtd <= 0) return;

  const totalLiquido = parseFloat(mensalidade.valor_total) || 0;
  if (totalLiquido <= 0) return;
  const valores = distribuir(centavos(mensalidade.valor_total),qtd);

  let dataVencimento = new Date(`${mensalidade.primeiro_vencimento}T00:00:00`);
  for (let i = 0; i < qtd; i++) {
    const vencIso = dataVencimento.toISOString().split("T")[0];
    mensalidade.pagamentos.push({
      forma_pagamento_id: "",
      data_vencimento: vencIso,
      valor: (valores[i]/100).toFixed(2),
      data_pagamento: null,
      data_recebimento: "",
      conta_financeira_id: null,
      numero_autorizacao: null,
      banco_numero: "",
      agencia: "",
      cheque_numero: ""
    });
    dataVencimento.setMonth(dataVencimento.getMonth() + 1);
  }
}

function isCheque(formaPagamentoId) {
  const forma = getFormaById(formaPagamentoId);
  if (!forma) return false;
  const codigo = String(forma.codigo_sistema || "").trim().toUpperCase();
  return codigo ? codigo === "CHEQUE" : String(forma.nome || "").trim().toLowerCase() === "cheque";
}

const existeCheque = computed(() =>
  mensalidade.pagamentos.some((p) => isCheque(p.forma_pagamento_id))
);

function atualizarObservacaoProrata() {
  if (c04Ativa) return;
  if (
    trocaManagedAtiva.value
  ) {
    return;
  }

  const valorTotalFmt = globalUtils.formatarValor(totalProrataBrutoNovoPlano.value, true);
  const dias = Number(diasRestantesVigencia.value || 0);

  mensalidade.observacoes =
    `O cálculo do Valor Total de ${valorTotalFmt} é referente aos ${dias} ${dias === 1 ? 'dia restante' : 'dias restantes'} do plano (pró-rata).`;
}

const formValid = computed(() => {
  if (c04Ativa) return previaAtualC04.value && (!previaC04.value.requerConferencia || conferenciaC04.value) && mensalidade.pagamentos.every(p=>p.forma_pagamento_id && (isFormaAInformar(p.forma_pagamento_id)||p.conta_financeira_id) && (!isFormaComAutorizacao(p.forma_pagamento_id)||String(p.numero_autorizacao||'').trim()));
  const planoValido =
    planoNovo.categoria_id &&
    planoNovo.tipo_plano_id &&
    planoNovo.nivel_id &&
    planoNovo.inicio_vigencia &&
    planoNovo.termino_vigencia &&
    planoNovo.aulas_semana &&
    planoNovo.quantidade_parcelas;

  const turmasValidas =
    Array.isArray(planoNovo.turmas) &&
    planoNovo.turmas.length > 0 &&
    planoNovo.turmas.every((t) => t.turma_id && t.turma_id !== "");

  const parcelasAdicionaisValidas = mensalidade.pagamentos
    .filter((p) => p.adicional)
    .every((p) => {
      let valorNum = 0;
      if (typeof p.valor === "string") {
        const v = p.valor.replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
        valorNum = parseFloat(v) || 0;
      } else {
        valorNum = p.valor;
      }
      return valorNum > 0;
    });

  if (
    trocaManagedAtiva.value
  ) {
    const valorMensal =
      normalizarMoedaManaged(
        mensalidade.valor
      );

    const desconto =
      normalizarPercentualManaged(
        mensalidade.desconto
      );

    const dia =
      Number(
        diaVencimentoMensalidadeTroca.value
      );

    const politicaValida =
      Number.isInteger(
        politicaCobrancaAplicavelId.value
      ) &&
      politicaCobrancaAplicavelId.value > 0;

    const diaValido =
      Number.isInteger(
        dia
      ) &&
      dia >= 1 &&
      dia <= 28 &&
      diasVencimentoCobranca.value
        .some(
          item =>
            item.dia ===
            dia
        );

    const regulares =
      parcelasRegularesTroca();

    const primeiraRegular =
      regulares[0];

    const formaId =
      Number(
        primeiraRegular
          ?.forma_pagamento_id
      );

    const contaId =
      Number(
        primeiraRegular
          ?.conta_financeira_id
      );

    const regularesCoerentes =
      regulares.length > 0 &&
      Number.isInteger(
        formaId
      ) &&
      formaId > 0 &&
      Number.isInteger(
        contaId
      ) &&
      contaId > 0 &&
      regulares.every(
        p =>
          isBoletoSemantico(
            p.forma_pagamento_id
          ) &&
          Number(
            p.forma_pagamento_id
          ) ===
            formaId &&
          Number(
            p.conta_financeira_id
          ) ===
            contaId &&
          !p.data_pagamento &&
          !p.data_recebimento
      );

    const previewValido =
      Boolean(
        previewTrocaManaged.value &&
        !carregandoPreviewTrocaManaged.value &&
        !erroPreviewTrocaManaged.value &&
        String(
          previewTrocaManaged.value
            ?.tipo_preview ||
          ""
        ).toUpperCase() ===
          "TROCA_PLANO" &&
        Number(
          previewTrocaManaged.value
            ?.matricula_id
        ) ===
          Number(
            props.planoAtual?.id
          ) &&
        Number(
          previewTrocaManaged.value
            ?.politica_cobranca_id
        ) ===
          Number(
            politicaCobrancaAplicavelId.value
          ) &&
        Number(
          previewTrocaManaged.value
            ?.dia_vencimento_mensalidade
        ) ===
          dia &&
        Array.isArray(
          previewTrocaManaged.value
            ?.obrigacoes
        ) &&
        previewTrocaManaged.value
          .obrigacoes
          .length ===
          regulares.length
      );

    return Boolean(
      planoValido &&
      turmasValidas &&
      valorMensal &&
      desconto !== null &&
      politicaValida &&
      diaValido &&
      mensalidade.primeiro_vencimento &&
      (regularesCoerentes || previewTrocaManaged.value?.composicao?.C === '0.00') &&
      previewValido &&
      parcelasAdicionaisValidas
    );
  }

  const mensalidadeValida =
    mensalidade.valor &&
    mensalidade.primeiro_vencimento &&
    mensalidade.quantidade_pagamentos &&
    Array.isArray(mensalidade.pagamentos) &&
    (Number(mensalidade.valor_total) === 0 || mensalidade.pagamentos.length > 0) &&
    mensalidade.pagamentos.every((p) => {
      const formaOk = !!p.forma_pagamento_id;
      const vencOk = !!p.data_vencimento;
      const contaOk = isFormaAInformar(p.forma_pagamento_id) ? true : !!p.conta_financeira_id;
      const autOk = isFormaComAutorizacao(p.forma_pagamento_id)
        ? !!(p.numero_autorizacao && String(p.numero_autorizacao).trim())
        : true;

      return formaOk && vencOk && contaOk && autOk;
    });

  const cartaoLinhasOk = mensalidade.pagamentos.every((p) => {
    if (!p.forma_pagamento_id) return true;
    if (!isCartao(p.forma_pagamento_id)) return true;
    return !!(p.numero_autorizacao && String(p.numero_autorizacao).trim());
  });

  if (!cartaoLinhasOk) return false;

  return centavos(totalDistribuido.value.toFixed(2)) === centavos(mensalidade.valor_total || 0) && !!versaoOrigem.value && !erroContexto.value && Number(mensalidade.valor_total) >= 0 && planoValido && turmasValidas && mensalidadeValida && parcelasAdicionaisValidas;
});

async function trocar() {
  if (c04Ativa) return confirmarC04();
  if (!isMatriculaAtiva.value) {
    alert("Não é possível trocar o plano de uma matrícula não ativa.");
    isSaving.value = false;
    return;
  }

  if (isSaving.value) return;
  if (trocaManagedAtiva.value) {
    if (
      !Array.isArray(planoNovo.turmas) ||
      !planoNovo.turmas.length ||
      planoNovo.turmas.some(t => !resolverTurmaSelecionada(t?.turma_id))
    ) {
      alert(mensagemTurmaIndisponivel);
      return;
    }
  } else {
    if (planoNovo.turmas.some(t => !resolverTurmaSelecionada(t.turma_id))) { alert(mensagemTurmaIndisponivel); return; }
  }
  isSaving.value = true;

  try {
    const userName = instance.appContext.config.globalProperties.$globalState.userName;
    const turmasCompletas = completarTurmas();

    let payload;

    if (
      trocaManagedAtiva.value
    ) {
      if (mensalidade.pagamentos.some(p => p.adicional)) throw new Error('Parcelas adicionais independentes devem ser tratadas fora da troca; esta operação cria somente o complemento.');
      const preview = previewTrocaManaged.value;
      if (!preview?.versao_origem || carregandoPreviewTrocaManaged.value || erroPreviewTrocaManaged.value) {
        throw new Error('Confira uma prévia válida antes de confirmar.');
      }
      const parcelasExibidas = preview.obrigacoes.map(p => ({ valor: p.valor, data_vencimento: p.data_vencimento, motivo: p.motivo || '' }));
      if (JSON.stringify(parcelasExibidas) !== distribuicaoValidadaComplemento) {
        throw new Error('Valide a distribuição ajustada antes de confirmar.');
      }
      payload = {
        id_matricula: props.planoAtual.id,
        numero_contrato: preview.contrato_atual,
        operacao_id: operacaoComplemento,
        versao_origem: preview.versao_origem,
        valor_mensalidade: normalizarMoedaManaged(mensalidade.valor),
        desconto_mensalidade: normalizarPercentualManaged(mensalidade.desconto),
        quantidade_complemento: quantidadeComplemento.value,
        parcelas_complemento: parcelasComplemento.value,
        motivo_ajuste: mensalidade.observacoes || '',
        planoNovo: { ...planoNovo, turmas: turmasCompletas },
        mensalidade: { pagamentos: [] },
        nome_usuario: userName,
        dia_vencimento_mensalidade: Number(diaVencimentoMensalidadeTroca.value),
        mensalidade_forma_pagamento_id: configuracaoComplemento.value.forma,
        mensalidade_conta_financeira_id: configuracaoComplemento.value.conta
      };
    } else {
      payload = {
        id_matricula: props.planoAtual.id,
        numero_contrato: props.planoAtual.numero_contrato,
        versao_origem: versaoOrigem.value,
        aluno: props.planoAtual.aluno,
        aluno_id: props.planoAtual.aluno_id,
        responsavel: props.planoAtual.responsavel,
        responsavel_id: props.planoAtual.responsavel_id,
        categoria_id: props.planoAtual.categoria_id,
        categoria: props.planoAtual.categoria,
        tipo_plano_id: props.planoAtual.tipo_plano_id,
        tipo_plano: props.planoAtual.tipo_plano,
        aulas_semana: props.planoAtual.aulas_semana,
        quantidade_parcelas: props.planoAtual.quantidade_parcelas,
        nivel_id: props.planoAtual.nivel_id,
        nivel: props.planoAtual.nivel,
        inicio_vigencia: props.planoAtual.inicio_vigencia,
        termino_vigencia: props.planoAtual.termino_vigencia,
        data_matricula: props.planoAtual.data_matricula,
        valor: props.planoAtual.valor,
        desconto: props.planoAtual.desconto,
        valor_com_desconto: props.planoAtual.valor_com_desconto,
        forma_pagamento_id: props.planoAtual.forma_pagamento_id,
        forma_pagamento: props.planoAtual.forma_pagamento,
        data_vencimento: props.planoAtual.data_vencimento,
        convenio_id: props.planoAtual.convenio_id,
        convenio: props.planoAtual.convenio,
        pagamento_pendente: props.planoAtual.pagamento_pendente,
        valor_mensalidade: valorParcelaPrevista.value || 0,
        desconto_mensalidade: props.planoAtual.desconto_mensalidade,
        valor_com_desconto_mensalidade: props.planoAtual.valor_com_desconto_mensalidade,
        primeiro_vencimento: props.planoAtual.primeiro_vencimento,
        quantidade_pagamentos: props.planoAtual.quantidade_pagamentos,
        valor_total: props.planoAtual.valor_total_mensalidade,
        contrato_atual: props.planoAtual.numero_contrato,
        total_quitado_plano_atual: Number(totalQuitado.value || 0),
        total_bruto_novo_plano: Number(totalBrutoNovoPlano.value || 0),
        total_a_pagar_novo_plano: Number(mensalidade.valor_total || 0),

        planoNovo: {
          ...planoNovo,
          turmas: turmasCompletas,
        },

        mensalidade: {
          ...mensalidade,
          pagamentos: mensalidade.pagamentos.map((p) => ({
            ...p,
            banco_numero: isCheque(p.forma_pagamento_id) ? p.banco_numero : null,
            agencia: isCheque(p.forma_pagamento_id) ? p.agencia : null,
            cheque_numero: isCheque(p.forma_pagamento_id) ? p.cheque_numero : null,
            adicional: p.adicional === true,
            data_pagamento: isFormaAInformar(p.forma_pagamento_id) ? "" : p.data_pagamento,
            conta_financeira_id: isFormaAInformar(p.forma_pagamento_id)
              ? null
              : p.conta_financeira_id
              ? parseInt(p.conta_financeira_id, 10)
              : null,
            data_recebimento: isFormaAInformar(p.forma_pagamento_id)
              ? null
              : p.data_pagamento && p.data_pagamento.trim() !== ""
              ? p.data_recebimento ||
                (isCartaoCreditoParcelado(p.forma_pagamento_id)
                  ? calcularDataRecebimento(
                      getDataBaseBlocoParcelado(p),
                      p.forma_pagamento_id,
                      getNumeroParcelaNoBlocoParcelado(p)
                    )
                  : calcularDataRecebimento(p.data_pagamento, p.forma_pagamento_id, 1))
              : null,
            numero_autorizacao: isFormaComAutorizacao(p.forma_pagamento_id)
              ? ((p.numero_autorizacao || "").trim() || null)
              : null,
          })),
        },

        nome_usuario: userName,
      };
    }

    const response = await axios.post(
      "/operacional/matriculas/salvar-trocas-planos",
      payload
    );

    emit("trocarSucesso", response.data);
    cancel();
  } catch (error) {
    console.error("Erro ao trocar plano:", error);

    if (trocaManagedAtiva.value) {
      alert(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Erro ao trocar plano. Verifique os logs para mais detalhes."
      );
    } else {
      alert(error.response?.data?.error || error.message || "Erro ao trocar plano. Verifique os logs para mais detalhes.");
    }
  } finally {
    isSaving.value = false;
  }
}

function desformatarValorAdicional(pagamento) {
  if (pagamento.valor) {
    const unformatted = pagamento.valor
      .replace(/\s/g, "")
      .replace("R$", "")
      .replace(/\./g, "")
      .trim();
    pagamento.valor = unformatted;
  }
}

function formatarValorAdicional(pagamento) {
  if (pagamento.valor) {
    let valorLimpo = pagamento.valor.replace(/\s/g, "").replace("R$", "").replace(/\./g, "");
    valorLimpo = valorLimpo.replace(",", ".");

    const numero = parseFloat(valorLimpo);
    if (isNaN(numero)) {
      pagamento.valor = "";
      return;
    }

    pagamento.valor = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(numero);
  }
}

const previaC04 = ref(null), erroC04 = ref(''), carregandoC04 = ref(false);
const conferenciaC04 = ref(false), chaveConferidaC04 = ref('');
const anteriorC04 = reactive({base:'',duracaoMeses:'',inicio:'',termino:''});
const conferenciaPreviaC04 = ref(false);
const baseFormatadaC04 = computed(() => anteriorC04.base === '' ? '' : new Intl.NumberFormat('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(anteriorC04.base)));
const operacaoC04 = window.crypto.randomUUID();
const resumoC04 = [['Valor anterior','baseElegivelCentavos'],['Crédito proporcional','creditoCentavos'],['Novo plano bruto','totalOriginalCentavos'],['Desconto comercial','descontoComercialCentavos'],['Crédito aplicado','creditoAplicadoCentavos'],['Valor líquido','valorLiquidoCentavos'],['Crédito excedente','creditoExcedenteCentavos']];
function terminoCivilC04(inicio, meses) {
  if (!inicio || !Number(meses)) return '';
  const d = new Date(`${inicio}T12:00:00Z`), dia = d.getUTCDate();
  d.setUTCDate(1); d.setUTCMonth(d.getUTCMonth()+Number(meses));
  d.setUTCDate(Math.min(dia,new Date(Date.UTC(d.getUTCFullYear(),d.getUTCMonth()+1,0)).getUTCDate()));
  d.setUTCDate(d.getUTCDate()-1);return d.toISOString().slice(0,10);
}
function dadosC04() {
  const ajustes = {}, encontrados = previaC04.value?.encontrados;
  if (encontrados) {
    const valores = {duracaoMeses:anteriorC04.duracaoMeses===''?null:Number(anteriorC04.duracaoMeses),inicio:anteriorC04.inicio,termino:anteriorC04.termino};
    for(const [k,v] of Object.entries(valores)) if(v!==null && v!=='' && v!==encontrados[k]) ajustes[k]=v;
  }
  const quantidade=Number(planoNovo.quantidade_parcelas), primeiro=mensalidade.primeiro_vencimento;
  const vencimentos=Array.from({length:quantidade},(_,i)=>{
    if(!primeiro) return '';
    const d=new Date(`${primeiro}T12:00:00Z`), dia=d.getUTCDate();d.setUTCDate(1);d.setUTCMonth(d.getUTCMonth()+i);
    d.setUTCDate(Math.min(dia,new Date(Date.UTC(d.getUTCFullYear(),d.getUTCMonth()+1,0)).getUTCDate()));
    return d.toISOString().slice(0,10);
  });
  // Alterações individuais de vencimento permanecem independentes da vigência.
  if(primeiro===previaC04.value?.vencimentos?.[0]) for(const p of mensalidade.pagamentos) if(p.numeroC04 && p.numeroC04<=quantidade) vencimentos[p.numeroC04-1]=p.data_vencimento;
  return {ajustesAnterior:ajustes,camposConferidos:conferenciaC04.value?['baseElegivelCentavos','duracaoMeses','inicio','termino']:[],vencimentos};
}
const previaAtualC04 = computed(() => Boolean(previaC04.value?.ok && previaC04.value?.calculo &&
  !carregandoC04.value && !erroC04.value && chaveC04.value === chaveConferidaC04.value));
const chaveC04 = computed(()=> {
  const {ajustesAnterior,vencimentos}=dadosC04();
  return JSON.stringify({plano:planoNovo,desconto:mensalidade.desconto,c04:{ajustesAnterior,vencimentos}});
});
function pedidoC04() {
  return {id_matricula:props.planoAtual.id,numero_contrato:props.planoAtual.numero_contrato,
    planoNovo:{...planoNovo,turmas:completarTurmas()},mensalidade:{desconto:String(mensalidade.desconto||0),primeiro_vencimento:mensalidade.primeiro_vencimento,observacoes:mensalidade.observacoes,pagamentos:mensalidade.pagamentos},c04:dadosC04()};
}
async function calcularC04() {
  if(carregandoC04.value) return;
  carregandoC04.value=true;erroC04.value='';
  const chave=chaveC04.value, conferencia=conferenciaC04.value;
  try {
    const {data}=await axios.post('/operacional/matriculas/salvar-trocas-planos/preview',pedidoC04());
    if(chave!==chaveC04.value) {erroC04.value='Os dados mudaram durante o cálculo. Atualize a prévia.';return;}
    previaC04.value=data;
    conferenciaPreviaC04.value=conferencia;
    if(data.utilizados) Object.assign(anteriorC04,{base:data.utilizados.baseElegivelCentavos==null?'':(data.utilizados.baseElegivelCentavos/100).toFixed(2),duracaoMeses:data.utilizados.duracaoMeses??'',inicio:data.utilizados.inicio??'',termino:data.utilizados.termino??''});
    if(data.calculo) {
      const anteriores=mensalidade.pagamentos;
      mensalidade.valor_total=(data.calculo.valorLiquidoCentavos/100).toFixed(2);
      mensalidade.valor_com_desconto=(data.calculo.totalAposDescontoCentavos/data.novo.quantidadeParcelas/100).toFixed(2);
      planoNovo.termino_vigencia=data.calculo.vigencia.termino;
      mensalidade.pagamentos=data.parcelasComVencimento.map((p,i)=>({...anteriores[i],numeroC04:p.numero,valor:(p.valorCentavos/100).toFixed(2),data_vencimento:p.dataVencimento,adicional:false}));
    }
    chaveConferidaC04.value=chaveC04.value;
    if(!data.ok) erroC04.value=data.bloqueio?.mensagem||'Confira ou complete os parâmetros históricos e atualize a prévia.';
  } catch(e) {erroC04.value=e.response?.data?.error||e.message;chaveConferidaC04.value='';}
  finally {carregandoC04.value=false;}
}
async function confirmarC04() {
  if(isSaving.value||!formValid.value) return;
  isSaving.value=true;
  try {
    // O aceite integra o token do backend, mas não a validade financeira local.
    // Sincroniza-o apenas ao confirmar, sem exigir recálculo manual no checkbox.
    if(conferenciaPreviaC04.value!==conferenciaC04.value) {
      const financeiro = p => JSON.stringify([p.calculo,p.utilizados,p.novo,p.parcelasComVencimento,p.obrigacoesPreservadas]);
      const anterior=financeiro(previaC04.value);
      await calcularC04();
      if(anterior!==financeiro(previaC04.value)) {
        erroC04.value='A prévia financeira mudou. Confira os valores e atualize a prévia antes de confirmar.';
        return;
      }
    }
    if(!formValid.value) return;
    const payload={...pedidoC04(),operacao_id:operacaoC04,versao_origem:previaC04.value.versao};
    const {data}=await axios.post('/operacional/matriculas/salvar-trocas-planos',payload);
    emit('trocarSucesso',data);cancel();
  } catch(e) {erroC04.value=e.response?.data?.error||e.message;}
  finally {isSaving.value=false;}
}

function cancel() {
  emit("cancelar");
}

onMounted(async () => {
  planoNovo.inicio_vigencia = todayIsoLocal();
  planoNovo.termino_vigencia = c04Ativa ? '' : toIsoDate(props.planoAtual?.termino_vigencia);

  await carregarCategorias();
  await carregarTodosTiposPlano();
  await carregarNiveis();
  await carregarFormasPagamento();
  await carregarConvenios();
  await carregarContasFinanceiras();

  if (isMatriculaAtiva.value) {
    await carregarParcelasQuitadas();
  }
});

function adicionarPagamento() {
  const ultima = mensalidade.pagamentos.filter(p=>!p.adicional).at(-1);
  const data = new Date(`${ultima?.data_vencimento || mensalidade.primeiro_vencimento}T12:00:00`);
  if (ultima) data.setMonth(data.getMonth()+1);
  mensalidade.pagamentos.push({forma_pagamento_id:"",valor:0,data_vencimento:data.toISOString().slice(0,10),data_pagamento:null,data_recebimento:null,conta_financeira_id:null,adicional:false});
  recalcularParcelas();
}
const totalDistribuido = computed(()=>mensalidade.pagamentos.filter(p=>!p.adicional).reduce((s,p)=>s+centavos(p.valor || 0),0)/100);
const totalMarcadoPago = computed(()=>parcelasQuitadas.value.filter(p=>p.data_pagamento || p.data_recebimento).reduce((s,p)=>s+centavos(p.valor_pago),0)/100);
const parcelasVariadas = computed(()=>new Set(mensalidade.pagamentos.filter(p=>!p.adicional).map(p=>centavos(p.valor))).size>1);


</script>

<style scoped>
.conferencia-historica {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.5rem;
}
.conferencia-historica input[type="checkbox"] {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  margin: 0.2em 0 0;
  padding: 0;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 1100px;
  border-radius: 0;
  overflow: hidden;
}
.modal-header {
  background: #f5f5f5;
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
}
.modal-footer {
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  background: #f5f5f5;
}
.btn-close {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}
.modal-body .form-label {
  font-size: 0.7rem;
  margin-bottom: 0.1rem;
}
.modal-body .section-title {
  font-size: 0.85rem;
}
.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}
.spacer {
  margin-bottom: 20px;
}
.form-section {
  background: white;
  padding: 15px;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}
.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}
.form-group {
  margin-bottom: 10px;
}
.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}
.required {
  color: red;
}
.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0px;
}
.turma-item,
.table .btn {
  margin-top: 0px;
}
.add-turma-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 70px;
  height: 25px;
}
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch {
  display: flex;
  align-items: center;
}
.toggle-switch label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 6px;
  min-width: 70px;
  border-radius: 20px;
  font-weight: bold;
}
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #007bff;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 4px 16px;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-align: center;
  position: relative;
}
.toggle-input:checked + .toggle-label {
  background-color: #dc3545;
}
.toggle-label:before {
  content: "";
  position: absolute;
  left: 5px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}
.toggle-input:checked + .toggle-label:before {
  transform: translateX(35px);
}
.toggle-label span {
  flex: 1;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
}
.spacer {
  margin-bottom: 20px;
}
.btn-warning {
  font-size: 12px;
}
.resumo-financeiro .form-control {
  border: 0;
  pointer-events: none;
}
.bg-light-emphasis {
  background: #eef7ff;
}
.resumo-financeiro .saldo {
  color: #0c3c78;
}
.resumo-box {
  border: 0;
  pointer-events: none;
  background: #f8f9fa;
}
.saldo {
  background: #eef7ff;
  color: #0c3c78;
}
.saldo-bg {
  background: #eef7ff;
}
.form-section {
  background: #fff;
  padding: 15px;
  border-radius: 0;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}
.saldo-bg {
  background: #eef7ff;
}
</style>
